import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "sc" }
const _hoisted_2 = {
  class: "sc__toolbar",
  "aria-label": "계약서 탭"
}
const _hoisted_3 = {
  class: "sc__tabs",
  role: "tablist"
}
const _hoisted_4 = ["aria-selected", "onClick"]
const _hoisted_5 = { class: "sc__tab-full" }
const _hoisted_6 = { class: "sc__tab-short" }
const _hoisted_7 = { class: "sc__actions" }
const _hoisted_8 = { class: "sc__action-btns" }
const _hoisted_9 = { class: "sc__action-group sc__action-group--staff" }
const _hoisted_10 = { class: "sc__action-group" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "sc__save-msg",
  role: "status"
}
const _hoisted_14 = { class: "sc__main" }
const _hoisted_15 = { class: "sc__table" }
const _hoisted_16 = ["onKeydown"]
const _hoisted_17 = { class: "sc__val" }
const _hoisted_18 = { class: "sc__val" }
const _hoisted_19 = { class: "sc__val" }
const _hoisted_20 = { class: "sc__val" }
const _hoisted_21 = { class: "sc__val" }
const _hoisted_22 = { class: "sc__sign" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "sc__sign-party" }
const _hoisted_25 = { class: "sc__val" }
const _hoisted_26 = { class: "sc__val" }
const _hoisted_27 = { class: "sc__sig-slot" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "sc__field" }
const _hoisted_30 = { class: "sc__field" }
const _hoisted_31 = { class: "sc__val" }
const _hoisted_32 = { class: "sc__val" }
const _hoisted_33 = { class: "sc__field" }
const _hoisted_34 = { class: "sc__field" }
const _hoisted_35 = { class: "sc__field" }
const _hoisted_36 = { class: "sc__field" }
const _hoisted_37 = { class: "sc__field" }
const _hoisted_38 = { class: "sc__field" }
const _hoisted_39 = { class: "sc__field" }
const _hoisted_40 = { class: "sc__field sc__sign-party" }
const _hoisted_41 = ["src"]
const _hoisted_42 = { class: "sc__val" }
const _hoisted_43 = { class: "sc__val" }
const _hoisted_44 = { class: "sc__sig-slot" }
const _hoisted_45 = ["src"]
const _hoisted_46 = { class: "sc__field sc__sign-party" }
const _hoisted_47 = ["src"]
const _hoisted_48 = { class: "sc__val" }
const _hoisted_49 = { class: "sc__val" }
const _hoisted_50 = { class: "sc__sig-slot" }
const _hoisted_51 = ["src"]
const _hoisted_52 = { class: "sc__field" }
const _hoisted_53 = { class: "sc__field" }
const _hoisted_54 = { class: "sc__field" }
const _hoisted_55 = { class: "sc__field" }
const _hoisted_56 = { class: "sc__field" }
const _hoisted_57 = { class: "sc__field" }
const _hoisted_58 = { class: "sc__field sc__sign-party" }
const _hoisted_59 = ["src"]
const _hoisted_60 = { class: "sc__field" }
const _hoisted_61 = { class: "sc__field" }
const _hoisted_62 = { class: "sc__field" }
const _hoisted_63 = { class: "sc__field sc__sign-party" }
const _hoisted_64 = ["src"]
const _hoisted_65 = { class: "sc__val" }
const _hoisted_66 = { class: "sc__val" }
const _hoisted_67 = { class: "sc__sig-slot" }
const _hoisted_68 = ["src"]
const _hoisted_69 = { class: "sc__field" }
const _hoisted_70 = { class: "sc__overview" }
const _hoisted_71 = { class: "sc__box" }
const _hoisted_72 = { class: "sc__box" }
const _hoisted_73 = {
  key: 0,
  class: "sc__fab-badge"
}
const _hoisted_74 = { class: "sc-pdf__panel" }
const _hoisted_75 = { class: "sc-pdf__head" }
const _hoisted_76 = { class: "sc-pdf__titles" }
const _hoisted_77 = { class: "sc-pdf__title" }
const _hoisted_78 = { class: "sc-pdf__body" }
const _hoisted_79 = {
  key: 0,
  class: "sc-pdf__status"
}
const _hoisted_80 = {
  key: 1,
  class: "sc-pdf__status sc-pdf__status--err"
}
const _hoisted_81 = { class: "sc-pdf__foot" }
const _hoisted_82 = { class: "sc-pdf__actions" }
const _hoisted_83 = ["disabled"]
const _hoisted_84 = ["disabled"]

import { computed, nextTick, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import ServiceContractFormSheet from '@/components/contract/ServiceContractFormSheet.vue'
import ContractGate from '@/components/contract/ContractGate.vue'
import ContractList from '@/components/contract/ContractList.vue'
import ContractSetup from '@/components/contract/ContractSetup.vue'
import ContractDeleteModal from '@/components/contract/ContractDeleteModal.vue'
import ContractPasswordModal from '@/components/contract/ContractPasswordModal.vue'
import ScMark from '@/components/contract/ScMark.vue'
import ServiceContractAnnex2Doc from '@/components/contract/ServiceContractAnnex2Doc.vue'
import ScEditText from '@/components/contract/ScEditText.vue'
import ScEditDate from '@/components/contract/ScEditDate.vue'
import { HAMWOORI_SEAL } from '@/constants/legalContent'
import { useDaumPostcode } from '@/composables/useDaumPostcode'
import {
  parseContractTab,
  SERVICE_CONTRACT_TABS,
  useServiceContractForm,
  type ServiceContractTab,
} from '@/composables/useServiceContractForm'
import { downloadPdfBlob, requestServiceContractPdfBlob } from '@/utils/serviceContractPdf'
import {
  deleteServiceContract,
  fetchServiceContract,
  fetchServiceContractList,
  getContractToken,
  isContractAuthError,
  type ServiceContractListItem,
  saveServiceContract,
  unlockServiceContract,
} from '@/api/serviceContract'
import type { ServiceContractForm } from '@/composables/useServiceContractForm'

const OPEN_KEY = 'jangi_sc_open'
type StaffAction = 'list' | 'setup'
type SheetSection = 'party' | 'annex1' | 'annex2' | 'annex3' | 'annex4' | 'sign'
const contractArticlesHtml = `
<h3>제1조  목적 및 계약 구조</h3>
<p>① 본 계약은 갑이 임금관리와 재무회계 중 하나 또는 모두를 선택하여 이용하는 경우, 선택한 서비스의 제공범위, 상호 의무, 수수료 정산, 자료보호 및 종료에 관한 공통조건을 정한다.</p>
<p>② 본문은 공통조건이며, 서비스 선택·개시연월·업무범위는 별첨 1, 이용요금·정산기준은 별첨 2, 자료제출·업무일정은 별첨 3, 개인정보 처리위탁은 별첨 4, 종료 인계는 별첨 5에 따른다.</p>
<p>③ 별첨은 당사자가 서명 또는 전자적 방법으로 합의한 때 본 계약의 일부가 된다. 법률상 강행규정에 반하는 내용은 해당 규정에 따라 해석한다.</p>
<h3>제2조  제공 서비스 및 제외 업무</h3>
<p>① 을은 갑이 별첨 1에서 “선택”으로 표시하고 서비스 개시연월을 확정한 업무에 한하여, 별첨 1의 세부 업무범위에 따라 서비스를 제공한다. 임금관리만 선택하면 임금관리 업무만, 재무회계만 선택하면 재무회계 업무만 수행하며, 두 서비스를 모두 선택한 경우에는 각 선택 범위에 따라 제공한다.</p>
<p>② 갑의 근로계약 체결·변경, 근로시간 및 수당 지급기준 확정, 임금 지급, 회계증빙 생성·보관, 예산·결산의 최종 승인, 행정기관 신고의무 등 법령상 사용자·시설 운영주체의 의무는 갑에게 있다.</p>
<p>③ 세무신고 대리, 조세 신고용 장부작성 대행, 노동관계 법령상 대리·서류작성·전문상담, 사회보험 신고의 대행·대리, 감사·법률의견 등 별도 자격이 필요한 업무는 이 계약만으로 제공되지 않는다. 관련 법률에 따라 적법하게 수행 가능한 주체와 별도 계약하거나 갑이 직접 수행한다.</p>
<p>④ 법령 또는 행정지침 변경으로 수행자격이나 서비스 적법성에 의문이 생기면 당사자는 해당 업무를 즉시 검토하고 필요시 범위·수행방식을 서면 조정한다.</p>
<p>⑤ 서비스명 또는 공통조항이 계약서에 함께 기재되어 있다는 사유만으로 미선택 서비스의 제공의무가 발생하지 않는다. 미선택 서비스에 관한 산출물 작성·자료 검토·업무기한 관리 등은 을의 업무범위에 포함되지 않으며, 갑도 그 서비스의 이용료를 지급하지 않는다.</p>
<h3>제3조  계약 효력 및 서비스 이용기간</h3>
<p>① 본 계약은 양 당사자가 서명·날인 또는 적법한 전자서명을 완료한 날 효력이 발생한다. 실제 서비스 제공의 개시연월은 별첨 1의 서비스별 기재를 따른다.</p>
<p>② 최초 계약기간은 별첨 1에서 최초로 개시되는 유료 서비스의 개시월 초일부터 1년으로 한다. 서비스의 추가 선택 시 해당 서비스는 별첨 1의 개시월부터 시작하고 공통 계약 종료일에 기간을 맞춘다.</p>
<p>③ 만료일 30일 전까지 어느 일방의 서면 해지 통지가 없으면 같은 기간 자동 갱신된다. 을은 갱신 예정일과 주요 조건을 미리 안내한다. 별첨 2의 요금 변경은 제10조에 따른 별도 합의가 필요하다.</p>
<p>④ 별첨 1에서 “미선택”으로 표시하거나 서비스 선택·개시연월에 대한 합의가 완료되지 않은 서비스는 개시하지 않는다. 선택한 서비스의 이용요금과 적용 조건은 별첨 2에서 확정하며, 미선택 서비스에는 이용료가 발생하지 않는다.</p>
<h3>제4조  제공 방식과 의사소통</h3>
<p>① 을은 자체 또는 적법하게 이용하는 제휴 시스템과 담당 인력을 사용하여 서비스를 제공하며, 갑에게 접근 권한과 자료 제출 경로를 안내한다.</p>
<p>② 담당자의 전화·원격 지원은 별첨 1의 제공범위 안에서 수행하고, 현장방문, 과거 기간 소급정리, 대량 자료정비 등은 별도 합의가 없는 한 기본 서비스에 포함되지 않는다.</p>
<p>③ 당사자는 업무지시 및 승인을 이메일, 시스템 기록, 전자문서 등 추적 가능한 수단으로 남긴다. 구두 요청 중 비용·책임·법적 신고에 영향을 주는 내용은 별도 확인을 거친다.</p>
<h3>제5조  갑의 자료 제공 및 확인 의무</h3>
<p>① 갑은 별첨 1에서 선택한 서비스의 수행에 필요한 자료만 별첨 3의 제출기한과 양식에 맞추어 정확하고 완전하게 제공한다. 임금관리 선택 시 근로계약·근태·입퇴사·급여 관련 자료를, 재무회계 선택 시 거래내역·수입·지출·증빙 관련 자료를 제공한다.</p>
<p>② 갑은 근로조건, 수당 적용기준, 비과세 요건, 거래의 실제 발생 여부와 증빙 적법성에 대한 기초 판단 및 최종 승인을 담당한다.</p>
<p>③ 누락·오류·지연이 확인되면 갑은 즉시 정정자료를 제공한다. 을은 명백한 불일치 또는 계산상 이상 징후를 알게 된 경우 합리적인 범위에서 갑에게 알리고 확인을 요청한다.</p>
<p>④ 자료 제출 지연 등 갑의 사유로 일정 준수가 어렵다면 을은 영향을 알리고 가능한 대체 일정을 제안한다. 갑의 귀책으로 지연된 부분에 대해서만 책임을 부담하지 않으며 을의 독립된 과실에는 적용되지 않는다.</p>
<h3>제6조  임금관리 지원 및 책임 구분</h3>
<p>① 본 조는 갑이 별첨 1에서 임금관리 서비스를 선택한 경우에만 적용한다. 을은 갑이 확정·전달한 자료를 기준으로 임금 항목별 산출, 급여대장·명세서 및 사회보험·근로소득세 관련 기초자료 작성 등을 별첨 1의 선택 범위에서 지원한다.</p>
<p>② 통상임금, 연장·야간·휴일수당, 비과세 항목의 적용은 갑이 제공한 근로조건 및 사실관계와 당시 유효한 법령 등을 전제로 한다. 법률 해석상 다툼이 있거나 별도의 자격업무에 해당하는 판단은 갑이 적격 전문가에게 확인한다.</p>
<p>③ 근로자에게 지급할 임금의 확정·지급, 법정기한 준수 및 사용자로서의 설명 책임은 갑에게 있다. 을의 계산오류 또는 입력·처리 실수로 발생한 손해는 제15조에 따라 처리한다.</p>
<p>④ 갑의 승인 이후 추가 정정이 필요한 경우 원인과 처리시한, 추가업무 여부를 기록하여 협의한다.</p>
<h3>제7조  재무회계 지원 및 책임 구분</h3>
<p>① 본 조는 갑이 별첨 1에서 재무회계 서비스를 선택한 경우에만 적용한다. 을은 갑의 자료를 바탕으로 수입·지출 분류, 전표입력 지원, 장부·결산 기초자료 생성 등을 별첨 1의 선택 범위에서 수행한다.</p>
<p>② 예산·결산서의 확정, 비용의 실제 집행, 증빙의 적법성, 법정 보고 및 시설 운영에 관한 의사결정은 갑의 책임이다. 관계 법령상 지정 회계시스템 또는 표준연계모듈 사용 의무가 있는 경우 갑과 을은 필요한 사용·연계 조건을 확인한다.</p>
<p>③ 제공된 증빙의 부재·허위·누락 등으로 생긴 오류는 원인에 따라 구분한다. 을이 정상적으로 제공된 자료를 잘못 처리한 경우에는 정정과 제15조의 책임 기준이 적용된다.</p>
<h3>제8조  산출물 확인과 수정</h3>
<p>① 을은 별첨 3에서 정한 일정에 따라 산출물을 시스템 또는 지정 수단으로 제공한다. 갑은 제공받은 산출물을 지급·제출 전에 확인하고 오류 발견 시 지체 없이 알려야 한다.</p>
<p>② 을은 자신의 귀책으로 발생한 오류를 합리적인 기한 내에 무상 시정한다. 갑의 자료 변경·지연에 따른 재작업은 별첨 2에 정한 별도 업무에 해당할 수 있으며 사전 견적·승인 없이 추가 비용을 청구하지 않는다.</p>
<p>③ 검토기간의 경과나 무응답만으로 을의 과실 또는 법정 책임이 면제되는 것은 아니다.</p>
<h3>제9조  서비스 이용료 및 정산</h3>
<p>① 을은 실제로 선택·개시된 서비스의 월 이용료만 청구한다. 서비스별 금액, 인원·업무량 산정기준, 부가가치세 포함 여부, 할인, 청구·납부일, 개시월·종료월 정산 및 추가업무 요금은 별첨 2에서 정한다. 미선택 서비스에 대해서는 별첨 1·2에 의한 추가 신청이 합의되기 전까지 기본료·관리비 등 어떠한 이용료도 청구하지 않는다.</p>
<p>② 을은 정산 근거를 확인할 수 있는 청구내역을 제공한다. 갑이 청구내역에 이의가 있으면 구체적인 사유를 알려 협의하며, 다툼이 없는 금액은 정해진 기한에 납부한다.</p>
<p>③ 합의된 납부기한을 경과한 경우 을은 상당한 기간을 정하여 납부를 최고할 수 있으며, 지연손해금은 법령의 허용 범위 및 별첨 2의 합의에 따른다.</p>
<h3>제10조  서비스 및 요금 변경</h3>
<p>① 갑이 미선택 서비스를 새로 추가하거나 이미 선택한 서비스의 제외, 대상 인원·업무량 또는 개시월 변경을 요청하는 경우 양 당사자는 별첨 1·2의 변경에 명시적으로 합의한 후 해당 서비스에 적용한다. 한 서비스를 신청·변경하였다는 이유만으로 다른 서비스가 자동 신청·변경되지 않는다.</p>
<p>② 을이 요금 또는 핵심 서비스 내용을 변경하고자 할 때에는 적용 예정일 30일 전까지 변경 사유와 내용을 알리고 갑의 명시적 동의를 받는다. 동의하지 않으면 기존 조건을 유지하는 범위에서 협의하거나 제17조에 따라 해지할 수 있다.</p>
<p>③ 보안·법령 준수에 필요한 경미한 기술 변경은 서비스의 본질적 기능을 불리하게 축소하지 않는 범위에서 사전 또는 사후 안내할 수 있다.</p>
<h3>제11조  시스템 이용·보안·장애</h3>
<p>① 갑은 계정 접근권한을 업무상 필요한 인원에게만 부여하고 인증정보를 안전하게 관리한다. 을은 합리적인 기술적·관리적 보호조치와 백업·복구절차를 운영한다.</p>
<p>② 예정된 점검은 가급적 사전 공지하고, 장애 발생 시 을은 신속히 복구에 착수하며 장애내용·예상 영향·대체 처리방법을 안내한다.</p>
<p>③ 시스템 장애가 법정 마감에 영향을 줄 우려가 있으면 당사자는 비상 연락과 대체 자료전달 방법에 협조한다. 어느 당사자도 단순한 장애 공지만으로 자신의 귀책책임을 면하지 않는다.</p>
<h3>제12조  협력업체 활용 및 개인정보 재위탁</h3>
<p>① 을은 서비스 품질 확보를 위하여 영업지사, 자료처리업체, 전산운영업체 등을 활용할 수 있으나, 개인정보 처리업무의 재위탁은 별첨 4 및 관련 법령에 따라 갑의 사전 동의를 받아야 한다.</p>
<p>② 개인정보를 처리하는 협력업체의 명칭·업무·처리항목은 별첨 4 또는 별도의 동의·고지문서에 명시하며, 변경 시에도 필요한 절차를 진행한다.</p>
<p>③ 을은 협력업체를 적절히 감독하고, 협력업체의 귀책사유가 을의 계약상 채무 이행에 영향을 미치는 경우 법률에 따라 책임을 부담한다. 전문자격 업무는 적법한 자격을 갖춘 자가 별도 수임·수행하도록 한다.</p>
<h3>제13조  개인정보 및 비밀유지</h3>
<p>① 갑은 선택한 서비스의 수행에 필요한 적법한 근거가 있는 개인정보만 을에게 제공하고 정보주체 고지 등 법률상 의무를 이행한다. 을은 별첨 1에서 선택하지 않은 서비스의 제공을 목적으로 자료를 요구하거나 처리하지 않는다.</p>
<p>② 주민등록번호 등 고유식별정보는 법령상 처리 근거와 필요성이 확인된 경우에만 최소 범위로 취급하며, 별첨 4에 따른 접근제한·암호화 등 보호조치를 시행한다.</p>
<p>③ 당사자는 업무상 알게 된 급여·인사·회계·영업정보를 계약 목적 외 이용하거나 부당하게 공개하지 않는다. 해당 의무는 계약 종료 후에도 정보의 성격 및 관계 법령에 따라 유지된다.</p>
<h3>제14조  자료 및 지식재산권</h3>
<p>① 갑이 제공한 원시자료 및 갑의 업무 데이터는 갑 또는 적법한 권리자에게 귀속한다. 을은 서비스 제공에 필요한 범위에서만 이를 이용한다.</p>
<p>② 을의 기존 소프트웨어, 알고리즘, 양식, 노하우 등에 관한 권리는 을 또는 정당한 권리자에게 유보된다. 갑은 계약기간 중 허용된 목적에 한하여 시스템을 이용할 수 있다.</p>
<p>③ 계약 종료 시 갑의 데이터는 제18조 및 별첨 5에 따라 제공하며, 권리 귀속과 무관하게 보안·개인정보 의무를 준수한다.</p>
<h3>제15조  오류 처리·손해배상</h3>
<p>① 손해가 발생하면 당사자는 사실관계와 원인을 공동으로 확인하고, 확대 방지·정정·이의신청에 합리적으로 협조한다.</p>
<p>② 귀책당사자는 계약 위반과 상당인과관계가 있는 통상손해를 배상하며, 특별손해는 상대방이 이를 알았거나 알 수 있었던 경우 관계 법령에 따른다. 과태료·가산세·추징 관련 비용도 발생 원인과 귀책 정도에 따라 검토한다.</p>
<p>③ 고의·중대한 과실, 개인정보 관련 법정 책임 등 법률상 제한할 수 없는 책임은 면책하거나 부당하게 축소하지 않는다. 손해액·원인에 다툼이 있는 경우 관련 자료로 협의하거나 법원의 판단에 따른다.</p>
<p>④ 당사자는 손해 확대를 방지하기 위한 합리적인 조치를 취해야 하며, 이미 시정·복구된 부분에 대하여 동일 손해를 중복 청구하지 않는다.</p>
<h3>제16조  불가항력</h3>
<p>① 천재지변, 대규모 통신망 장애, 정부의 긴급조치 등 합리적으로 통제할 수 없는 사유로 이행이 지연되면 영향을 받은 당사자는 즉시 상대방에게 알리고 피해 최소화에 협조한다.</p>
<p>② 불가항력으로 인정되는 범위에서는 책임을 부담하지 않으나, 사전 대비의무 위반이나 귀책사유로 확대된 손해까지 면제되는 것은 아니다.</p>
<h3>제17조  이용제한 및 계약 해지</h3>
<p>① 당사자 일방은 상대방에게 30일 전 서면 또는 기록이 남는 전자적 방법으로 통지하여 계약을 해지할 수 있다. 이미 수행한 업무의 이용료·확정된 비용은 별첨 2에 따라 정산한다.</p>
<p>② 중대한 계약 위반이 있고 서면 시정요구 후 14일 이내 시정되지 않으면 상대방은 계약을 해지할 수 있다. 개인정보 침해의 중대한 위험, 위법행위 강요, 파산 등 계약 목적 달성이 현저히 어려운 사유에는 필요한 범위에서 즉시 해지할 수 있다.</p>
<p>③ 정당한 사유 없이 합의된 이용료가 연체되면 을은 사전 최고와 시정기회를 부여한 뒤 비필수 기능의 이용을 제한할 수 있다. 임금지급·법정신고 기한이 임박한 자료의 접근을 부당하게 차단하거나 데이터 반환을 담보수단으로 사용하지 않는다.</p>
<p>④ 임금관리와 재무회계는 각각 독립적으로 신청·해지할 수 있다. 어느 하나의 서비스만 종료하는 경우 그 서비스의 업무수행과 과금만 종료하고, 다른 선택 서비스는 종전 조건대로 계속한다. 종료되는 서비스의 대금은 종료일까지의 실제 제공분을 별첨 2에 따라 정산하며, 계약 해지에 따른 별도 위약금은 사전 개별 서면 합의가 없는 한 부과하지 않는다.</p>
<h3>제18조  종료 시 자료 반환·인계</h3>
<p>① 전체 계약 또는 개별 선택 서비스 종료 시 갑은 별첨 5에 따라 해당 서비스의 업무 데이터를 요청할 수 있다. 을은 종료되는 서비스에 관련된 통상적 전자파일 추출 및 계약상 인계 범위에 협조하며, 계속 이용하는 다른 서비스의 제공은 유지한다.</p>
<p>② 통상적인 자료 추출 외의 특수 변환·현장지원 등 추가업무에는 사전 견적과 갑의 동의가 있는 경우에만 비용을 청구한다.</p>
<p>③ 을은 개인정보를 목적 달성 또는 계약 종료 후 법령상 보존사유가 없는 범위에서 지체 없이 반환·파기하고 그 결과를 확인할 수 있도록 한다. 법령상 보존이 필요한 자료는 안전하게 분리 보관한다.</p>
<h3>제19조  통지 및 합의 방법</h3>
<p>① 당사자의 공식 연락처는 계약서 또는 별첨 1에 기재하고 변경 시 지체 없이 통보한다.</p>
<p>② 업무범위·요금·개시월 등 중요한 변경은 양 당사자의 서명, 전자서명, 확인 가능한 전자문서 또는 시스템상 명시적 승인을 통해 합의한다. 단순 열람·침묵만으로 중요한 변경에 동의한 것으로 보지 않는다.</p>
<h3>제20조  분쟁 해결 및 기타</h3>
<p>① 본 계약과 관련하여 분쟁이 발생하면 당사자는 성실히 협의하여 해결한다. 협의로 해결되지 않아 소송을 제기하는 경우, 관계 법령상 전속관할이 정해진 사건을 제외하고 을의 본점 소재지를 관할하는 법원을 제1심 합의관할법원으로 한다.</p>
<p>② 본 계약에서 정하지 않은 사항은 관계 법령 및 신의성실 원칙에 따른다. 일부 조항이 무효로 판단되어도 다른 조항의 효력은 법적으로 허용되는 범위에서 유지된다.</p>
<p>③ 본 계약은 본문과 합의된 별첨을 포함하며, 당사자 각 1부씩 보관하거나 동일한 효력의 전자문서로 보존한다.</p>
`

const annex4Html = `
<h3>제1항  당사자 및 목적</h3>
<p class="sc__field">갑은 개인정보 처리위탁자, 을은 수탁자로서 장기요양기관의 종사자 임금관리 및 재무회계 시스템 운영과 관련하여 별첨 1에서 실제 선택·개시한 서비스에 필요한 개인정보 처리업무만 위탁·수탁한다. 미선택 서비스는 이 위탁 범위에 포함되지 않는다.</p>
<p class="sc__field">업무 목적: 선택한 서비스의 급여 관련 기초자료 정리 또는 회계처리 지원 및 그에 부수하는 사용자 인증·접근관리, 이용 이력·오류 대응 등 계약된 업무 수행.</p>
<h3>제2항  대상과 범위</h3>
<p class="sc__field">정보주체: 갑의 종사자, 급여·회계처리와 관련된 거래 상대방 등 실제 업무에 필요한 자.</p>
<p class="sc__field">항목: 성명, 연락처, 입·퇴사 및 근무정보, 급여·공제·계좌정보, 거래 증빙에 포함된 정보 중 계약 업무에 필요한 최소항목. 주민등록번호·고유식별정보는 별도 법적 근거와 필요성이 확인된 경우에만 처리한다.</p>
<p class="sc__field">처리 행위: 수집(갑으로부터 수령), 저장, 조회, 가공, 출력, 수정, 전송(승인된 범위), 삭제·반환. 목적 외 활용·홍보 이용·독자적 제3자 제공 금지.</p>
<h3>제3항  위탁 기간·자료 제공 근거</h3>
<p class="sc__field">위탁 기간: 별첨 1에 따른 서비스 개시 시부터 관련 개인정보의 반환·파기 완료 시까지로 하되, 계약 종료 및 법령상 보존규정을 우선 적용한다.</p>
<p class="sc__field">갑은 해당 자료 처리의 적법한 근거를 확보하고 처리위탁 사항을 관련 법령에 따라 공개하며 정보주체 권리요청에 대한 1차 처리창구가 된다.</p>
<h3>제4항  기술적·관리적 안전조치</h3>
<p class="sc__field">을은 최소권한 부여, 접근기록 관리, 접속통제, 필요한 항목의 암호화, 전송구간 보호, 백업·복구, 직원 교육, 보안사고 대응 등 적용 법령·고시에 따른 안전조치를 시행한다.</p>
<p class="sc__field">개인정보를 처리하는 인력에 비밀유지 의무를 부과하고 권한 변경·퇴사 시 접근권한을 신속히 회수한다.</p>
<h3>제5항  재위탁 동의</h3>
<p class="sc__field">을이 개인정보 처리업무를 제3자에게 재위탁하려면 해당 업체·재위탁 업무·처리 항목·기간을 갑에게 고지하고 사전에 동의받는다. 기존에 동의한 업체·범위를 변경하는 경우에도 필요한 동의·고지 절차를 따른다.</p>
<h3>제6항  감독·점검 및 유출 대응</h3>
<p class="sc__field">갑은 법령에 따른 범위에서 업무 처리현황과 안전조치 준수 여부에 대한 자료 제출·점검을 요청할 수 있고, 을은 합리적으로 협조한다.</p>
<p class="sc__field">을은 개인정보 침해·유출 등을 인지하면 지체 없이 갑에게 사고 내용, 영향 범위, 대응 조치 및 연락 창구를 알리고 법정 신고·통지에 협조한다.</p>
<h3>제7항  목적 외 이용 금지·권리요청 대응</h3>
<p class="sc__field">을은 정보주체의 열람·정정·삭제·처리정지 요구가 전달되면 적법한 범위에서 갑과 협조한다. 갑의 지시가 법률에 위반될 소지가 있으면 을은 이를 고지하고 시정을 요청할 수 있다.</p>
<h3>제8항  반환·파기·보존</h3>
<p class="sc__field">계약 종료 또는 위탁 목적 달성 시 을은 갑의 요청 및 법령에 따라 개인정보를 안전하게 반환하거나 파기하고 그 결과를 확인할 수 있도록 한다.</p>
<p class="sc__field">보존의무가 있는 자료는 보존근거·항목·기간을 구분하여 접근을 제한한 뒤 기간 경과 시 파기한다.</p>
<h3>제9항  책임 및 효력</h3>
<p class="sc__field">개인정보 처리에 관한 양 당사자의 책임은 개인정보 보호법 등 관계 법령과 본 계약 제15조에 따른다. 본 별첨은 본계약의 일부이며 개인정보 보호를 위한 법정 의무에 우선하여 적용될 수 없다.</p>
`


export default /*@__PURE__*/_defineComponent({
  __name: 'ContractPage',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const tabs = SERVICE_CONTRACT_TABS
const { form, company, filledCount, blank, replaceForm, clearDraft, freezeAnnex2 } = useServiceContractForm(route.query)

const unlocked = ref(Boolean(getContractToken()))
const view = ref<'list' | 'setup' | 'editor'>('list')
const contracts = ref<ServiceContractListItem[]>([])
const listLoading = ref(false)
const listError = ref('')
const contractId = ref<number | null>(null)
const saving = ref(false)
const saveMessage = ref('')
const deleteOpen = ref(false)
const deleteBusy = ref(false)
const deleteError = ref('')
const deleteTarget = ref<ServiceContractListItem | null>(null)
const deleteTargetName = computed(() => deleteTarget.value?.orgName || form.orgName || '')

/* 피계약자가 탭을 들고 있을 때 직원 동작(목록·다시 작성)은 비밀번호를 다시 묻는다 */
const staffGateOpen = ref(false)
const staffGateBusy = ref(false)
const staffGateError = ref('')
const pendingStaffAction = ref<StaffAction | null>(null)
const staffGateReason = computed(() =>
  pendingStaffAction.value === 'setup'
    ? '함우리 정보와 별첨 2 고치기는'
    : '계약서 목록 보기는',
)

function askStaffGate(action: StaffAction) {
  pendingStaffAction.value = action
  staffGateError.value = ''
  staffGateOpen.value = true
}

function closeStaffGate() {
  if (staffGateBusy.value) return
  staffGateOpen.value = false
  staffGateError.value = ''
  pendingStaffAction.value = null
}

async function onStaffGateConfirm(password: string) {
  if (staffGateBusy.value) return
  staffGateBusy.value = true
  staffGateError.value = ''
  try {
    await unlockServiceContract(password)
    staffGateOpen.value = false
    const action = pendingStaffAction.value
    pendingStaffAction.value = null
    if (action === 'list') goList()
    else if (action === 'setup') backToSetup()
  } catch (e) {
    staffGateError.value = e instanceof Error ? e.message : '비밀번호가 맞지 않습니다.'
  } finally {
    staffGateBusy.value = false
  }
}

/* 「재위탁 없음」에 체크하면 ①·② 칸은 원문처럼 빈칸으로 둔다 (값은 지우지 않음) */
const reconsignVal = (row: 'reconsign1' | 'reconsign2', key: 'vendor' | 'work' | 'items' | 'agreedDate') =>
  (form.reconsignNone ? '' : form[row][key])

const tab = ref<ServiceContractTab>(parseContractTab(route.query.tab || route.hash.replace(/^#tab=/, '')))
const sheetOpen = ref(false)
const sheetSection = ref<SheetSection>('party')

/* 문서의 「(서명)」 자리를 누르면 시트를 서명 단계로 바로 연다 */
function openSheet(sec: SheetSection = 'party') {
  sheetSection.value = sec
  sheetOpen.value = true
}

/* 서명란 대표자는 「대표자」와 같은 값 — 옛 초안의 별도 서명성명은 쓰는 순간 정리한다 */
function setSignName(v: string) {
  form.partyASignName = ''
  form.representative = v
}

/* 별첨 3 갑 담당자도 「담당자」와 같은 값 */
function setAnnex3PartyA(v: string) {
  form.annex3PartyA = ''
  form.contactName = v
}

/* 소재지 칸을 누르면 다음 주소검색 — 상세주소는 옆 칸에 직접 입력 */
const { searchPostcode } = useDaumPostcode()
async function onSearchAddress() {
  try {
    const result = await searchPostcode()
    if (!result) return
    form.zipcode = result.zipcode
    form.address = [result.address, result.extra].filter(Boolean).join(' ')
  } catch (e) {
    window.alert(e instanceof Error ? e.message : '주소 검색을 열지 못했습니다.')
  }
}
const pdfBusy = ref(false)
const pdfPreviewOpen = ref(false)
const pdfPreviewUrl = ref('')
const pdfBlob = ref<Blob | null>(null)
const pdfFilename = ref('')
const pdfError = ref('')
const pdfPagesRef = ref<HTMLElement | null>(null)
let pdfPagesHandle: { pageCount: number; destroy: () => Promise<void> } | null = null

const panelContract = ref<HTMLElement | null>(null)
const panelAnnex1 = ref<HTMLElement | null>(null)
const panelAnnex2 = ref<HTMLElement | null>(null)
const panelAnnex3 = ref<HTMLElement | null>(null)
const panelAnnex4 = ref<HTMLElement | null>(null)
const panelSummary = ref<HTMLElement | null>(null)

function setTab(id: ServiceContractTab) {
  tab.value = id
  router.replace({
    query: { ...route.query, tab: id },
    hash: '',
  })
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

function selectLabel(v: string) {
  if (v === 'selected') return '선택'
  if (v === 'unselected') return '미선택'
  return '미입력'
}

function revokePdfUrl() {
  if (pdfPreviewUrl.value) {
    URL.revokeObjectURL(pdfPreviewUrl.value)
    pdfPreviewUrl.value = ''
  }
}

function closePdfPreview() {
  pdfPreviewOpen.value = false
  pdfBusy.value = false
  pdfError.value = ''
  pdfBlob.value = null
  pdfFilename.value = ''
  if (pdfPagesHandle) {
    pdfPagesHandle.destroy().catch(() => {})
    pdfPagesHandle = null
  }
  revokePdfUrl()
}

async function onPdf() {
  if (pdfBusy.value) return
  revokePdfUrl()
  pdfBlob.value = null
  pdfFilename.value = ''
  pdfError.value = ''
  pdfPreviewOpen.value = true
  pdfBusy.value = true
  try {
    const payload = JSON.parse(JSON.stringify(form)) as Record<string, unknown>
    const { blob, filename } = await requestServiceContractPdfBlob('all', payload)
    pdfBlob.value = blob
    pdfFilename.value = filename
    pdfPreviewUrl.value = URL.createObjectURL(blob)
    /* 폰·태블릿에서도 보이도록 pdf.js canvas 렌더링 (무거워서 동적 import) */
    await nextTick()
    if (!pdfPagesRef.value) throw new Error('미리보기 영역을 찾지 못했습니다.')
    const { renderPdfPages } = await import('@/utils/pdfPreview')
    const handle = await renderPdfPages(blob, pdfPagesRef.value, () => !pdfPreviewOpen.value)
    if (!pdfPreviewOpen.value) {
      await handle.destroy().catch(() => {})
      return
    }
    pdfPagesHandle = handle
  } catch (e) {
    if (pdfPreviewOpen.value) {
      pdfError.value = e instanceof Error ? e.message : 'PDF를 만들지 못했습니다.'
    }
  } finally {
    pdfBusy.value = false
  }
}

function onDownloadPdf() {
  if (!pdfBlob.value) return
  downloadPdfBlob(pdfBlob.value, pdfFilename.value || '함우리_서비스계약서.pdf')
}

function onOpenPdfTab() {
  if (!pdfPreviewUrl.value) return
  window.open(pdfPreviewUrl.value, '_blank', 'noopener')
}

function onPdfKeydown(e: KeyboardEvent) {
  if (e.key === 'Escape' && pdfPreviewOpen.value) closePdfPreview()
}

watch(
  () => route.query.tab,
  (v) => {
    tab.value = parseContractTab(v)
  },
)

function lockAgain() {
  unlocked.value = false
  view.value = 'list'
}

function rememberOpen(value: string) {
  sessionStorage.setItem(OPEN_KEY, value)
}

async function loadList() {
  listLoading.value = true
  listError.value = ''
  try {
    contracts.value = await fetchServiceContractList()
  } catch (e) {
    if (isContractAuthError(e)) {
      lockAgain()
      return
    }
    listError.value = e instanceof Error ? e.message : '목록을 불러오지 못했습니다.'
  } finally {
    listLoading.value = false
  }
}

function onUnlocked() {
  unlocked.value = true
  view.value = 'list'
  sessionStorage.removeItem(OPEN_KEY)
  loadList()
}

function goList() {
  closePdfPreview()
  sheetOpen.value = false
  view.value = 'list'
  sessionStorage.removeItem(OPEN_KEY)
  saveMessage.value = ''
  loadList()
}

function onCreate() {
  freezeAnnex2(false)
  clearDraft()
  contractId.value = null
  saveMessage.value = ''
  view.value = 'setup'
  rememberOpen('setup')
}

function onSetupDone() {
  freezeAnnex2(true)
  view.value = 'editor'
  rememberOpen(contractId.value ? String(contractId.value) : 'new')
  setTab(form.annex2Mode === 'text' ? 'annex2' : 'contract')
}

/* 함우리 정보·별첨 2는 문서에서 못 고치니, 고칠 일이 있으면 작성 화면으로 돌려보낸다 */
function backToSetup() {
  freezeAnnex2(false)
  saveMessage.value = ''
  view.value = 'setup'
  rememberOpen(contractId.value ? `setup:${contractId.value}` : 'setup')
}

async function onOpen(id: number) {
  try {
    const data = await fetchServiceContract(id)
    replaceForm(data.form as Partial<ServiceContractForm>)
    freezeAnnex2(true)
    contractId.value = id
    saveMessage.value = ''
    view.value = 'editor'
    rememberOpen(String(id))
    setTab('contract')
  } catch (e) {
    if (isContractAuthError(e)) {
      lockAgain()
      return
    }
    listError.value = e instanceof Error ? e.message : '계약서를 열지 못했습니다.'
    view.value = 'list'
  }
}

async function onSave() {
  if (saving.value) return
  saving.value = true
  saveMessage.value = ''
  try {
    const payload = JSON.parse(JSON.stringify(form)) as Record<string, unknown>
    const id = await saveServiceContract(contractId.value, payload)
    contractId.value = id
    rememberOpen(String(id))
    saveMessage.value = '저장했습니다.'
  } catch (e) {
    if (isContractAuthError(e)) {
      lockAgain()
      return
    }
    saveMessage.value = e instanceof Error ? e.message : '저장하지 못했습니다.'
  } finally {
    saving.value = false
  }
}

function onAskDelete(item: ServiceContractListItem) {
  deleteTarget.value = item
  deleteError.value = ''
  deleteOpen.value = true
}

function onAskDeleteCurrent() {
  if (!contractId.value) return
  deleteTarget.value = {
    id: contractId.value,
    orgName: form.orgName,
    facilityCode: form.facilityCode,
    legalName: form.legalName,
    representative: form.representative,
    wageSelect: form.wageSelect,
    acctSelect: form.acctSelect,
    annex2Mode: form.annex2Mode,
    hasSign: Boolean(form.partyASignImage),
    createdAt: '',
    updatedAt: '',
  }
  deleteError.value = ''
  deleteOpen.value = true
}

function closeDelete() {
  if (deleteBusy.value) return
  deleteOpen.value = false
  deleteError.value = ''
}

async function onConfirmDelete(password: string) {
  const id = deleteTarget.value?.id
  if (!id || deleteBusy.value) return
  deleteBusy.value = true
  deleteError.value = ''
  try {
    await deleteServiceContract(id, password)
    deleteOpen.value = false
    if (contractId.value === id) {
      clearDraft()
      contractId.value = null
      view.value = 'list'
      sessionStorage.removeItem(OPEN_KEY)
    }
    await loadList()
  } catch (e) {
    if (isContractAuthError(e)) {
      deleteOpen.value = false
      lockAgain()
      return
    }
    deleteError.value = e instanceof Error ? e.message : '삭제하지 못했습니다.'
  } finally {
    deleteBusy.value = false
  }
}

async function restoreEditor() {
  const open = sessionStorage.getItem(OPEN_KEY)
  if (open === 'setup') {
    freezeAnnex2(false)
    view.value = 'setup'
    contractId.value = null
    return
  }
  if (open?.startsWith('setup:')) {
    const setupId = Number(open.slice(6))
    freezeAnnex2(false)
    view.value = 'setup'
    contractId.value = Number.isInteger(setupId) && setupId > 0 ? setupId : null
    return
  }
  if (open === 'new') {
    freezeAnnex2(true)
    view.value = 'editor'
    contractId.value = null
    return
  }
  const id = Number(open)
  if (open && Number.isInteger(id) && id > 0) {
    await onOpen(id)
    return
  }
  view.value = 'list'
  await loadList()
}

onMounted(() => {
  document.body.classList.add('sc-page')
  window.addEventListener('keydown', onPdfKeydown)
  if (unlocked.value) restoreEditor()
})

onUnmounted(() => {
  document.body.classList.remove('sc-page')
  window.removeEventListener('keydown', onPdfKeydown)
  closePdfPreview()
})

const pageTitle = computed(() => {
  if (view.value === 'list') return '계약서 목록 · 장기요양지원센터'
  if (view.value === 'setup') return '새 계약서 · 장기요양지원센터'
  const label = tabs.find((t) => t.id === tab.value)?.label || '계약서'
  return `${label} · 장기요양지원센터`
})

watch(
  pageTitle,
  (t) => {
    document.title = t
  },
  { immediate: true },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!unlocked.value)
      ? (_openBlock(), _createBlock(ContractGate, {
          key: 0,
          onUnlocked: onUnlocked
        }))
      : (view.value === 'list')
        ? (_openBlock(), _createBlock(ContractList, {
            key: 1,
            items: contracts.value,
            loading: listLoading.value,
            error: listError.value,
            onCreate: onCreate,
            onOpen: onOpen,
            onRemove: onAskDelete,
            onRefresh: loadList
          }, null, 8, ["items", "loading", "error"]))
        : (view.value === 'setup')
          ? (_openBlock(), _createBlock(ContractSetup, {
              key: 2,
              form: _unref(form),
              onBack: _cache[0] || (_cache[0] = ($event: any) => (askStaffGate('list'))),
              onContinue: onSetupDone
            }, null, 8, ["form"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _cache[273] || (_cache[273] = _createElementVNode("header", { class: "sc__hero" }, [
                _createElementVNode("p", { class: "sc__eyebrow" }, "HAMWOORI / SERVICE AGREEMENT"),
                _createElementVNode("h1", { class: "sc__title" }, "임금관리 · 재무회계 표준계약서"),
                _createElementVNode("p", { class: "sc__lead" }, [
                  _createTextVNode(" 임금관리 또는 재무회계 중 필요한 서비스만 선택하세요. 시작연월·요금은 별첨에 기재합니다."),
                  _createElementVNode("br"),
                  _createTextVNode(" 문서의 빈칸과 ☐를 누르면 그 자리에서 바로 입력됩니다. 을 정보와 별첨 2는 이미 작성된 내용으로 표시됩니다. ")
                ])
              ], -1)),
              _createElementVNode("nav", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (t) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: t.id,
                      type: "button",
                      role: "tab",
                      class: _normalizeClass(["sc__tab", { 'is-active': tab.value === t.id }]),
                      "aria-selected": tab.value === t.id,
                      onClick: ($event: any) => (setTab(t.id))
                    }, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(t.label), 1),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(t.short), 1)
                    ], 10, _hoisted_4))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[103] || (_cache[103] = _createElementVNode("p", { class: "sc__note" }, "빈칸·☐ 눌러 바로 입력 · PDF는 본문+별첨 1~4 전체", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "sc__btn sc__btn--ghost",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (askStaffGate('list')))
                      }, "목록"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "sc__btn sc__btn--ghost",
                        title: "함우리 정보와 별첨 2를 고치러 작성 화면으로 돌아갑니다",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (askStaffGate('setup')))
                      }, " 다시 작성 "),
                      (contractId.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "sc__btn sc__btn--danger",
                            onClick: onAskDeleteCurrent
                          }, " 삭제 "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "sc__btn sc__btn--ghost",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (openSheet()))
                      }, "정보 입력"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "sc__btn sc__btn--ghost",
                        title: "본문과 별첨 1~4 전체를 PDF로 봅니다",
                        disabled: pdfBusy.value,
                        onClick: onPdf
                      }, _toDisplayString(pdfBusy.value ? 'PDF 준비 중…' : 'PDF 미리보기'), 9, _hoisted_11),
                      _createElementVNode("button", {
                        type: "button",
                        class: "sc__btn sc__btn--teal",
                        disabled: saving.value,
                        onClick: onSave
                      }, _toDisplayString(saving.value ? '저장 중…' : '저장'), 9, _hoisted_12)
                    ])
                  ]),
                  (saveMessage.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(saveMessage.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("main", _hoisted_14, [
                _withDirectives(_createElementVNode("section", {
                  ref_key: "panelContract",
                  ref: panelContract,
                  class: _normalizeClass(["sc__panel", { 'is-active': tab.value === 'contract' }])
                }, [
                  _cache[131] || (_cache[131] = _createElementVNode("div", { class: "sc__topline" }, null, -1)),
                  _cache[132] || (_cache[132] = _createElementVNode("p", { class: "sc__doctype" }, "기본계약서 · 공통조항", -1)),
                  _cache[133] || (_cache[133] = _createElementVNode("h2", null, "장기요양기관 임금관리·재무회계 서비스 이용계약서", -1)),
                  _cache[134] || (_cache[134] = _createElementVNode("p", { class: "sc__intro" }, " 장기요양기관 또는 그 적법한 운영주체(이하 “갑”)와 주식회사 함우리(이하 “을”)는 갑이 선택한 임금관리 또는 재무회계 관련 전산·사무지원 서비스 이용에 관하여 다음과 같이 계약한다. 두 서비스 중 어느 하나만 선택하거나 모두 선택할 수 있으며, 서비스별 개시연월·업무범위·요금은 별첨에서만 정한다. ", -1)),
                  _cache[135] || (_cache[135] = _createElementVNode("h3", null, "계약 당사자", -1)),
                  _createElementVNode("table", _hoisted_15, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[106] || (_cache[106] = _createElementVNode("th", null, "갑 | 장기요양기관 또는 운영주체", -1)),
                        _createElementVNode("td", null, [
                          _cache[104] || (_cache[104] = _createTextVNode(" 기관명 ", -1)),
                          _createVNode(ScEditText, {
                            modelValue: _unref(form).orgName,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).orgName) = $event))
                          }, null, 8, ["modelValue"]),
                          _cache[105] || (_cache[105] = _createTextVNode(" 기관기호 ", -1)),
                          _createVNode(ScEditText, {
                            modelValue: _unref(form).facilityCode,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).facilityCode) = $event)),
                            width: 8,
                            numeric: ""
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[109] || (_cache[109] = _createElementVNode("th", null, "갑 | 계약 주체", -1)),
                        _createElementVNode("td", null, [
                          _cache[107] || (_cache[107] = _createTextVNode(" 법인/사업자명 ", -1)),
                          _createVNode(ScEditText, {
                            modelValue: _unref(form).legalName,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).legalName) = $event))
                          }, null, 8, ["modelValue"]),
                          _cache[108] || (_cache[108] = _createTextVNode(" 대표자 ", -1)),
                          _createVNode(ScEditText, {
                            modelValue: _unref(form).representative,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).representative) = $event)),
                            width: 8
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[112] || (_cache[112] = _createElementVNode("th", null, "갑 | 추가 정보", -1)),
                        _createElementVNode("td", null, [
                          _cache[110] || (_cache[110] = _createTextVNode(" 사업자등록번호 ", -1)),
                          _createVNode(ScEditText, {
                            modelValue: _unref(form).bizNumber,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).bizNumber) = $event)),
                            width: 10,
                            numeric: ""
                          }, null, 8, ["modelValue"]),
                          _cache[111] || (_cache[111] = _createTextVNode(" 소재지 ", -1)),
                          _createElementVNode("span", {
                            class: "sc__val sc-edit sc-edit--addr",
                            role: "button",
                            tabindex: "0",
                            "aria-label": "주소 검색",
                            onClick: onSearchAddress,
                            onKeydown: _withKeys(_withModifiers(onSearchAddress, ["prevent"]), ["enter"])
                          }, _toDisplayString(_unref(blank)(_unref(form).address, 16)), 41, _hoisted_16),
                          _createVNode(ScEditText, {
                            modelValue: _unref(form).addressDetail,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).addressDetail) = $event)),
                            width: 8,
                            placeholder: "상세주소"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[115] || (_cache[115] = _createElementVNode("th", null, "을 | 서비스 제공자", -1)),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(form).partyBLegalName), 1),
                          _cache[113] || (_cache[113] = _createTextVNode(" 사업자등록번호 ", -1)),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(form).partyBBizNumber), 1),
                          _cache[114] || (_cache[114] = _createTextVNode(" 대표자 ", -1)),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(form).partyBOwner), 1)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[118] || (_cache[118] = _createElementVNode("th", null, "을 | 연락 정보", -1)),
                        _createElementVNode("td", null, [
                          _cache[116] || (_cache[116] = _createTextVNode(" 소재지 ", -1)),
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(form).partyBAddress), 1),
                          _cache[117] || (_cache[117] = _createTextVNode(" 연락처 ", -1)),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(form).partyBPhone), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "sc__articles",
                    innerHTML: contractArticlesHtml
                  }),
                  _cache[136] || (_cache[136] = _createElementVNode("h3", null, "계약 당사자 서명", -1)),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("p", null, [
                      _cache[119] || (_cache[119] = _createTextVNode("체결일 ", -1)),
                      _createVNode(ScEditDate, {
                        y: _unref(form).signedYear,
                        "onUpdate:y": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).signedYear) = $event)),
                        m: _unref(form).signedMonth,
                        "onUpdate:m": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).signedMonth) = $event)),
                        d: _unref(form).signedDay,
                        "onUpdate:d": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form).signedDay) = $event))
                      }, null, 8, ["y", "m", "d"])
                    ]),
                    _createElementVNode("p", null, [
                      _cache[121] || (_cache[121] = _createTextVNode(" 갑: 기관명 ", -1)),
                      _createVNode(ScEditText, {
                        modelValue: _unref(form).orgName,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(form).orgName) = $event))
                      }, null, 8, ["modelValue"]),
                      _cache[122] || (_cache[122] = _createTextVNode(" 대표자 ", -1)),
                      _createVNode(ScEditText, {
                        "model-value": _unref(form).partyASignName || _unref(form).representative,
                        width: 8,
                        "onUpdate:modelValue": setSignName
                      }, null, 8, ["model-value"]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "sc__sig-slot sc__sig-slot--btn",
                        "aria-label": "갑 서명 입력",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (openSheet('sign')))
                      }, [
                        _cache[120] || (_cache[120] = _createTextVNode("(서명/날인)", -1)),
                        (_unref(form).partyASignImage)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "sc__sig-img",
                              src: _unref(form).partyASignImage,
                              alt: "갑 전자서명"
                            }, null, 8, _hoisted_23))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_24, [
                      _createElementVNode("span", null, [
                        _cache[124] || (_cache[124] = _createTextVNode(" 을: ", -1)),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(form).partyBLegalName), 1),
                        _cache[125] || (_cache[125] = _createTextVNode(" 대표자 ", -1)),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(form).partyBOwner), 1),
                        _createElementVNode("span", _hoisted_27, [
                          _cache[123] || (_cache[123] = _createTextVNode("(서명/날인)", -1)),
                          _createElementVNode("img", {
                            class: "sc__seal",
                            src: _unref(HAMWOORI_SEAL),
                            alt: "주식회사 함우리 직인",
                            width: "64",
                            height: "64"
                          }, null, 8, _hoisted_28)
                        ])
                      ])
                    ]),
                    _createElementVNode("p", null, [
                      _cache[126] || (_cache[126] = _createTextVNode(" 합의된 별첨: ", -1)),
                      _createVNode(ScMark, {
                        on: _unref(form).annexAgreed.a1,
                        "aria-label": "별첨 1 합의",
                        onPick: _cache[15] || (_cache[15] = ($event: any) => (_unref(form).annexAgreed.a1 = !_unref(form).annexAgreed.a1))
                      }, null, 8, ["on"]),
                      _cache[127] || (_cache[127] = _createTextVNode(" 별첨 1 ", -1)),
                      _createVNode(ScMark, {
                        on: _unref(form).annexAgreed.a2,
                        "aria-label": "별첨 2 합의",
                        onPick: _cache[16] || (_cache[16] = ($event: any) => (_unref(form).annexAgreed.a2 = !_unref(form).annexAgreed.a2))
                      }, null, 8, ["on"]),
                      _cache[128] || (_cache[128] = _createTextVNode(" 별첨 2 ", -1)),
                      _createVNode(ScMark, {
                        on: _unref(form).annexAgreed.a3,
                        "aria-label": "별첨 3 합의",
                        onPick: _cache[17] || (_cache[17] = ($event: any) => (_unref(form).annexAgreed.a3 = !_unref(form).annexAgreed.a3))
                      }, null, 8, ["on"]),
                      _cache[129] || (_cache[129] = _createTextVNode(" 별첨 3 ", -1)),
                      _createVNode(ScMark, {
                        on: _unref(form).annexAgreed.a4,
                        "aria-label": "별첨 4 합의",
                        onPick: _cache[18] || (_cache[18] = ($event: any) => (_unref(form).annexAgreed.a4 = !_unref(form).annexAgreed.a4))
                      }, null, 8, ["on"]),
                      _cache[130] || (_cache[130] = _createTextVNode(" 별첨 4 ", -1))
                    ])
                  ])
                ], 2), [
                  [_vShow, tab.value === 'contract']
                ]),
                _withDirectives(_createElementVNode("section", {
                  ref_key: "panelAnnex1",
                  ref: panelAnnex1,
                  class: _normalizeClass(["sc__panel", { 'is-active': tab.value === 'annex1' }])
                }, [
                  _cache[174] || (_cache[174] = _createElementVNode("div", { class: "sc__topline" }, null, -1)),
                  _cache[175] || (_cache[175] = _createElementVNode("p", { class: "sc__doctype" }, "별첨 1", -1)),
                  _cache[176] || (_cache[176] = _createElementVNode("h2", null, "서비스 선택·개시연월 및 업무범위 확인서", -1)),
                  _cache[177] || (_cache[177] = _createElementVNode("h3", null, "1. 기관 및 담당자", -1)),
                  _createElementVNode("p", _hoisted_29, [
                    _cache[137] || (_cache[137] = _createTextVNode(" 기관명 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).orgName,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(form).orgName) = $event))
                    }, null, 8, ["modelValue"]),
                    _cache[138] || (_cache[138] = _createTextVNode(" / 기관기호 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).facilityCode,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(form).facilityCode) = $event)),
                      width: 8,
                      numeric: ""
                    }, null, 8, ["modelValue"]),
                    _cache[139] || (_cache[139] = _createTextVNode(" / 담당자 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).contactName,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(form).contactName) = $event)),
                      width: 8
                    }, null, 8, ["modelValue"]),
                    _cache[140] || (_cache[140] = _createTextVNode(" / 이메일 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).contactEmail,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(form).contactEmail) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("p", _hoisted_30, [
                    _cache[141] || (_cache[141] = _createTextVNode(" 함우리 담당조직 ", -1)),
                    _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(form).partyBOrg || _unref(blank)('', 6)), 1),
                    _cache[142] || (_cache[142] = _createTextVNode(" / 연락처 ", -1)),
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(form).partyBPhone), 1),
                    _cache[143] || (_cache[143] = _createTextVNode(" / 계약서 체결일 ", -1)),
                    _createVNode(ScEditDate, {
                      y: _unref(form).signedYear,
                      "onUpdate:y": _cache[23] || (_cache[23] = ($event: any) => ((_unref(form).signedYear) = $event)),
                      m: _unref(form).signedMonth,
                      "onUpdate:m": _cache[24] || (_cache[24] = ($event: any) => ((_unref(form).signedMonth) = $event)),
                      d: _unref(form).signedDay,
                      "onUpdate:d": _cache[25] || (_cache[25] = ($event: any) => ((_unref(form).signedDay) = $event))
                    }, null, 8, ["y", "m", "d"])
                  ]),
                  _cache[178] || (_cache[178] = _createElementVNode("h3", null, "2. 서비스 선택과 시작 시점 (각 서비스별 “선택/미선택” 중 하나만 표시)", -1)),
                  _createElementVNode("p", _hoisted_33, [
                    _cache[144] || (_cache[144] = _createTextVNode(" 임금관리 서비스 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).wageSelect === 'selected',
                      "aria-label": "임금관리 선택",
                      onPick: _cache[26] || (_cache[26] = ($event: any) => (_unref(form).wageSelect = 'selected'))
                    }, null, 8, ["on"]),
                    _cache[145] || (_cache[145] = _createTextVNode(" 선택 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).wageSelect === 'unselected',
                      "aria-label": "임금관리 미선택",
                      onPick: _cache[27] || (_cache[27] = ($event: any) => (_unref(form).wageSelect = 'unselected'))
                    }, null, 8, ["on"]),
                    _cache[146] || (_cache[146] = _createTextVNode(" 미선택 선택한 경우 시작연월 ", -1)),
                    _createVNode(ScEditDate, {
                      y: _unref(form).wageStartYear,
                      "onUpdate:y": _cache[28] || (_cache[28] = ($event: any) => ((_unref(form).wageStartYear) = $event)),
                      m: _unref(form).wageStartMonth,
                      "onUpdate:m": _cache[29] || (_cache[29] = ($event: any) => ((_unref(form).wageStartMonth) = $event)),
                      type: "ym",
                      disabled: _unref(form).wageSelect !== 'selected'
                    }, null, 8, ["y", "m", "disabled"])
                  ]),
                  _createElementVNode("p", _hoisted_34, [
                    _cache[147] || (_cache[147] = _createTextVNode(" 재무회계 서비스 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).acctSelect === 'selected',
                      "aria-label": "재무회계 선택",
                      onPick: _cache[30] || (_cache[30] = ($event: any) => (_unref(form).acctSelect = 'selected'))
                    }, null, 8, ["on"]),
                    _cache[148] || (_cache[148] = _createTextVNode(" 선택 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).acctSelect === 'unselected',
                      "aria-label": "재무회계 미선택",
                      onPick: _cache[31] || (_cache[31] = ($event: any) => (_unref(form).acctSelect = 'unselected'))
                    }, null, 8, ["on"]),
                    _cache[149] || (_cache[149] = _createTextVNode(" 미선택 선택한 경우 시작연월 ", -1)),
                    _createVNode(ScEditDate, {
                      y: _unref(form).acctStartYear,
                      "onUpdate:y": _cache[32] || (_cache[32] = ($event: any) => ((_unref(form).acctStartYear) = $event)),
                      m: _unref(form).acctStartMonth,
                      "onUpdate:m": _cache[33] || (_cache[33] = ($event: any) => ((_unref(form).acctStartMonth) = $event)),
                      type: "ym",
                      disabled: _unref(form).acctSelect !== 'selected'
                    }, null, 8, ["y", "m", "disabled"])
                  ]),
                  _cache[179] || (_cache[179] = _createElementVNode("p", { class: "sc__field" }, " ※ 작성 예시: 임금관리만 이용하면 “임금관리 선택 / 재무회계 미선택”에 표시합니다. 재무회계만 이용하는 경우는 반대로 표시합니다. 두 서비스 모두 이용하는 경우 각각 “선택”에 표시합니다. ", -1)),
                  _cache[180] || (_cache[180] = _createElementVNode("p", { class: "sc__field" }, " ※ 선택한 서비스만 개시·제공·과금하며, 미선택 서비스는 업무 수행 및 이용료 청구 대상에서 제외한다. 미선택 서비스의 시작연월은 기재하지 않는다. 선택한 서비스의 시작연월은 해당 월의 1일로 본다. ", -1)),
                  _createElementVNode("p", _hoisted_35, [
                    _cache[150] || (_cache[150] = _createTextVNode(" 공통 계약 최초 종료연월 ", -1)),
                    _createVNode(ScEditDate, {
                      y: _unref(form).contractEndYear,
                      "onUpdate:y": _cache[34] || (_cache[34] = ($event: any) => ((_unref(form).contractEndYear) = $event)),
                      m: _unref(form).contractEndMonth,
                      "onUpdate:m": _cache[35] || (_cache[35] = ($event: any) => ((_unref(form).contractEndMonth) = $event)),
                      type: "ym"
                    }, null, 8, ["y", "m"]),
                    _cache[151] || (_cache[151] = _createTextVNode(" (최초 선택 서비스 개시월로부터 12개월째의 말일) ", -1))
                  ]),
                  _cache[181] || (_cache[181] = _createElementVNode("h3", null, "3. 선택 서비스 세부 범위", -1)),
                  _createElementVNode("p", _hoisted_36, [
                    _cache[152] || (_cache[152] = _createTextVNode(" 임금관리(선택한 경우에만 체크): ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).wageScopes.baseInput,
                      disabled: _unref(form).wageSelect !== 'selected',
                      "aria-label": "급여기초자료 입력·정리",
                      onPick: _cache[36] || (_cache[36] = ($event: any) => (_unref(form).wageScopes.baseInput = !_unref(form).wageScopes.baseInput))
                    }, null, 8, ["on", "disabled"]),
                    _cache[153] || (_cache[153] = _createTextVNode(" 급여기초자료 입력·정리 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).wageScopes.payroll,
                      disabled: _unref(form).wageSelect !== 'selected',
                      "aria-label": "임금 자동산출·급여대장",
                      onPick: _cache[37] || (_cache[37] = ($event: any) => (_unref(form).wageScopes.payroll = !_unref(form).wageScopes.payroll))
                    }, null, 8, ["on", "disabled"]),
                    _cache[154] || (_cache[154] = _createTextVNode(" 임금 자동산출·급여대장 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).wageScopes.payslip,
                      disabled: _unref(form).wageSelect !== 'selected',
                      "aria-label": "급여명세서 작성 지원",
                      onPick: _cache[38] || (_cache[38] = ($event: any) => (_unref(form).wageScopes.payslip = !_unref(form).wageScopes.payslip))
                    }, null, 8, ["on", "disabled"]),
                    _cache[155] || (_cache[155] = _createTextVNode(" 급여명세서 작성 지원 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).wageScopes.insurance,
                      disabled: _unref(form).wageSelect !== 'selected',
                      "aria-label": "사회보험·세무 관련 기초자료",
                      onPick: _cache[39] || (_cache[39] = ($event: any) => (_unref(form).wageScopes.insurance = !_unref(form).wageScopes.insurance))
                    }, null, 8, ["on", "disabled"]),
                    _cache[156] || (_cache[156] = _createTextVNode(" 사회보험·세무 관련 기초자료 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).wageScopes.other,
                      disabled: _unref(form).wageSelect !== 'selected',
                      "aria-label": "기타",
                      onPick: _cache[40] || (_cache[40] = ($event: any) => (_unref(form).wageScopes.other = !_unref(form).wageScopes.other))
                    }, null, 8, ["on", "disabled"]),
                    _cache[157] || (_cache[157] = _createTextVNode(" 기타 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).wageScopes.otherText,
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_unref(form).wageScopes.otherText) = $event)),
                      width: 8,
                      disabled: _unref(form).wageSelect !== 'selected' || !_unref(form).wageScopes.other
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _createElementVNode("p", _hoisted_37, [
                    _cache[158] || (_cache[158] = _createTextVNode(" 재무회계(선택한 경우에만 체크): ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).acctScopes.incomeExpense,
                      disabled: _unref(form).acctSelect !== 'selected',
                      "aria-label": "수입·지출자료 정리",
                      onPick: _cache[42] || (_cache[42] = ($event: any) => (_unref(form).acctScopes.incomeExpense = !_unref(form).acctScopes.incomeExpense))
                    }, null, 8, ["on", "disabled"]),
                    _cache[159] || (_cache[159] = _createTextVNode(" 수입·지출자료 정리 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).acctScopes.voucher,
                      disabled: _unref(form).acctSelect !== 'selected',
                      "aria-label": "계정과목 분류·전표입력 지원",
                      onPick: _cache[43] || (_cache[43] = ($event: any) => (_unref(form).acctScopes.voucher = !_unref(form).acctScopes.voucher))
                    }, null, 8, ["on", "disabled"]),
                    _cache[160] || (_cache[160] = _createTextVNode(" 계정과목 분류·전표입력 지원 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).acctScopes.books,
                      disabled: _unref(form).acctSelect !== 'selected',
                      "aria-label": "월별 장부·관리자료",
                      onPick: _cache[44] || (_cache[44] = ($event: any) => (_unref(form).acctScopes.books = !_unref(form).acctScopes.books))
                    }, null, 8, ["on", "disabled"]),
                    _cache[161] || (_cache[161] = _createTextVNode(" 월별 장부·관리자료 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).acctScopes.budget,
                      disabled: _unref(form).acctSelect !== 'selected',
                      "aria-label": "예산·결산 기초자료",
                      onPick: _cache[45] || (_cache[45] = ($event: any) => (_unref(form).acctScopes.budget = !_unref(form).acctScopes.budget))
                    }, null, 8, ["on", "disabled"]),
                    _cache[162] || (_cache[162] = _createTextVNode(" 예산·결산 기초자료 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).acctScopes.other,
                      disabled: _unref(form).acctSelect !== 'selected',
                      "aria-label": "기타",
                      onPick: _cache[46] || (_cache[46] = ($event: any) => (_unref(form).acctScopes.other = !_unref(form).acctScopes.other))
                    }, null, 8, ["on", "disabled"]),
                    _cache[163] || (_cache[163] = _createTextVNode(" 기타 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).acctScopes.otherText,
                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_unref(form).acctScopes.otherText) = $event)),
                      width: 8,
                      disabled: _unref(form).acctSelect !== 'selected' || !_unref(form).acctScopes.other
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _createElementVNode("p", _hoisted_38, [
                    _cache[164] || (_cache[164] = _createTextVNode(" 별도 전문자격자 수행: ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).specialist === 'none',
                      "aria-label": "전문자격자 없음",
                      onPick: _cache[48] || (_cache[48] = ($event: any) => (_unref(form).specialist = 'none'))
                    }, null, 8, ["on"]),
                    _cache[165] || (_cache[165] = _createTextVNode(" 없음 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).specialist === 'yes',
                      "aria-label": "전문자격자 있음",
                      onPick: _cache[49] || (_cache[49] = ($event: any) => (_unref(form).specialist = 'yes'))
                    }, null, 8, ["on"]),
                    _cache[166] || (_cache[166] = _createTextVNode(" 있음(별도 계약 주체·업무명 기재) ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).specialistDetail,
                      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_unref(form).specialistDetail) = $event)),
                      disabled: _unref(form).specialist !== 'yes'
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _createElementVNode("p", _hoisted_39, [
                    _cache[167] || (_cache[167] = _createTextVNode(" 추가업무(소급정리·현장방문 등): ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).extraWork,
                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_unref(form).extraWork) = $event)),
                      width: 20
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[182] || (_cache[182] = _createElementVNode("h3", null, "4. 확인 및 합의", -1)),
                  _cache[183] || (_cache[183] = _createElementVNode("p", { class: "sc__field" }, " 본 별첨에서 “선택”으로 표시하고 시작연월을 합의한 서비스만 계약상 제공 대상이다. 미선택 서비스는 제공·과금하지 않으며, 향후 추가 신청 시 별첨 1·2를 변경하여 합의한다. 서비스별 이용요금은 별첨 2에 따른다. ", -1)),
                  _createElementVNode("p", _hoisted_40, [
                    _createElementVNode("span", null, [
                      _cache[170] || (_cache[170] = _createTextVNode(" 갑 기관명 ", -1)),
                      _createVNode(ScEditText, {
                        modelValue: _unref(form).orgName,
                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_unref(form).orgName) = $event))
                      }, null, 8, ["modelValue"]),
                      _cache[171] || (_cache[171] = _createTextVNode(" 대표자 ", -1)),
                      _createVNode(ScEditText, {
                        "model-value": _unref(form).partyASignName || _unref(form).representative,
                        width: 8,
                        "onUpdate:modelValue": setSignName
                      }, null, 8, ["model-value"]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "sc__sig-slot sc__sig-slot--btn",
                        "aria-label": "갑 서명 입력",
                        onClick: _cache[53] || (_cache[53] = ($event: any) => (openSheet('sign')))
                      }, [
                        _cache[168] || (_cache[168] = _createTextVNode("(서명)", -1)),
                        (_unref(form).partyASignImage)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "sc__sig-img",
                              src: _unref(form).partyASignImage,
                              alt: "갑 전자서명"
                            }, null, 8, _hoisted_41))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[172] || (_cache[172] = _createTextVNode(" 을 ", -1)),
                      _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(form).partyBLegalName), 1),
                      _cache[173] || (_cache[173] = _createTextVNode(" 대표자 ", -1)),
                      _createElementVNode("span", _hoisted_43, _toDisplayString(_unref(form).partyBOwner), 1),
                      _createElementVNode("span", _hoisted_44, [
                        _cache[169] || (_cache[169] = _createTextVNode("(서명)", -1)),
                        _createElementVNode("img", {
                          class: "sc__seal",
                          src: _unref(HAMWOORI_SEAL),
                          alt: "주식회사 함우리 직인",
                          width: "56",
                          height: "56"
                        }, null, 8, _hoisted_45)
                      ])
                    ])
                  ])
                ], 2), [
                  [_vShow, tab.value === 'annex1']
                ]),
                _withDirectives(_createElementVNode("section", {
                  ref_key: "panelAnnex2",
                  ref: panelAnnex2,
                  class: _normalizeClass(["sc__panel", { 'is-active': tab.value === 'annex2' }])
                }, [
                  _cache[190] || (_cache[190] = _createElementVNode("div", { class: "sc__topline" }, null, -1)),
                  _cache[191] || (_cache[191] = _createElementVNode("p", { class: "sc__doctype" }, "별첨 2", -1)),
                  _cache[192] || (_cache[192] = _createElementVNode("h2", null, "서비스 요금·청구 및 정산 합의서", -1)),
                  _createVNode(ServiceContractAnnex2Doc, {
                    form: _unref(form),
                    locked: ""
                  }, null, 8, ["form"]),
                  _createElementVNode("h3", null, _toDisplayString(_unref(form).annex2Mode === 'text' ? '확인' : '4. 확인'), 1),
                  _createElementVNode("p", _hoisted_46, [
                    _createElementVNode("span", null, [
                      _cache[186] || (_cache[186] = _createTextVNode(" 갑 기관명 ", -1)),
                      _createVNode(ScEditText, {
                        modelValue: _unref(form).orgName,
                        "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_unref(form).orgName) = $event))
                      }, null, 8, ["modelValue"]),
                      _cache[187] || (_cache[187] = _createTextVNode(" 대표자 ", -1)),
                      _createVNode(ScEditText, {
                        "model-value": _unref(form).partyASignName || _unref(form).representative,
                        width: 8,
                        "onUpdate:modelValue": setSignName
                      }, null, 8, ["model-value"]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "sc__sig-slot sc__sig-slot--btn",
                        "aria-label": "갑 서명 입력",
                        onClick: _cache[55] || (_cache[55] = ($event: any) => (openSheet('sign')))
                      }, [
                        _cache[184] || (_cache[184] = _createTextVNode("(서명)", -1)),
                        (_unref(form).partyASignImage)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "sc__sig-img",
                              src: _unref(form).partyASignImage,
                              alt: "갑 전자서명"
                            }, null, 8, _hoisted_47))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[188] || (_cache[188] = _createTextVNode(" 을 ", -1)),
                      _createElementVNode("span", _hoisted_48, _toDisplayString(_unref(form).partyBLegalName), 1),
                      _cache[189] || (_cache[189] = _createTextVNode(" 대표자 ", -1)),
                      _createElementVNode("span", _hoisted_49, _toDisplayString(_unref(form).partyBOwner), 1),
                      _createElementVNode("span", _hoisted_50, [
                        _cache[185] || (_cache[185] = _createTextVNode("(서명)", -1)),
                        _createElementVNode("img", {
                          class: "sc__seal",
                          src: _unref(HAMWOORI_SEAL),
                          alt: "주식회사 함우리 직인",
                          width: "56",
                          height: "56"
                        }, null, 8, _hoisted_51)
                      ])
                    ])
                  ])
                ], 2), [
                  [_vShow, tab.value === 'annex2']
                ]),
                _withDirectives(_createElementVNode("section", {
                  ref_key: "panelAnnex3",
                  ref: panelAnnex3,
                  class: _normalizeClass(["sc__panel", { 'is-active': tab.value === 'annex3' }])
                }, [
                  _cache[222] || (_cache[222] = _createElementVNode("div", { class: "sc__topline" }, null, -1)),
                  _cache[223] || (_cache[223] = _createElementVNode("p", { class: "sc__doctype" }, "별첨 3", -1)),
                  _cache[224] || (_cache[224] = _createElementVNode("h2", null, "자료 제출·업무처리 및 검토 기준표", -1)),
                  _cache[225] || (_cache[225] = _createElementVNode("h3", null, "1. 주요 업무 처리 일정", -1)),
                  _createElementVNode("p", _hoisted_52, [
                    _cache[193] || (_cache[193] = _createTextVNode(" 임금관리(선택한 경우에만 작성): 갑 급여 기초자료 제출 [매월 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).wageSubmitDay,
                      "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_unref(form).wageSubmitDay) = $event)),
                      width: 4,
                      numeric: "",
                      disabled: _unref(form).wageSelect !== 'selected'
                    }, null, 8, ["modelValue", "disabled"]),
                    _cache[194] || (_cache[194] = _createTextVNode("일] / 을 급여대장·명세서 제공 목표 [매월 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).wageProvideDay,
                      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_unref(form).wageProvideDay) = $event)),
                      width: 4,
                      numeric: "",
                      disabled: _unref(form).wageSelect !== 'selected'
                    }, null, 8, ["modelValue", "disabled"]),
                    _cache[195] || (_cache[195] = _createTextVNode("일] / 갑 최종 확인 [매월 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).wageConfirmDay,
                      "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_unref(form).wageConfirmDay) = $event)),
                      width: 4,
                      numeric: "",
                      disabled: _unref(form).wageSelect !== 'selected'
                    }, null, 8, ["modelValue", "disabled"]),
                    _cache[196] || (_cache[196] = _createTextVNode("일] ", -1))
                  ]),
                  _createElementVNode("p", _hoisted_53, [
                    _cache[197] || (_cache[197] = _createTextVNode(" 재무회계(선택한 경우에만 작성): 갑 전월 증빙 제출 [매월 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).acctSubmitDay,
                      "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_unref(form).acctSubmitDay) = $event)),
                      width: 4,
                      numeric: "",
                      disabled: _unref(form).acctSelect !== 'selected'
                    }, null, 8, ["modelValue", "disabled"]),
                    _cache[198] || (_cache[198] = _createTextVNode("일] / 을 장부·전표 정리 목표 [매월 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).acctProvideDay,
                      "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_unref(form).acctProvideDay) = $event)),
                      width: 4,
                      numeric: "",
                      disabled: _unref(form).acctSelect !== 'selected'
                    }, null, 8, ["modelValue", "disabled"]),
                    _cache[199] || (_cache[199] = _createTextVNode("일] / 갑 확인 [매월 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).acctConfirmDay,
                      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_unref(form).acctConfirmDay) = $event)),
                      width: 4,
                      numeric: "",
                      disabled: _unref(form).acctSelect !== 'selected'
                    }, null, 8, ["modelValue", "disabled"]),
                    _cache[200] || (_cache[200] = _createTextVNode("일] ", -1))
                  ]),
                  _createElementVNode("p", _hoisted_54, [
                    _cache[201] || (_cache[201] = _createTextVNode(" 자료 전달 수단 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).deliveryMethod,
                      "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_unref(form).deliveryMethod) = $event))
                    }, null, 8, ["modelValue"]),
                    _cache[202] || (_cache[202] = _createTextVNode(" / 장애 시 대체 연락처 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).backupContact,
                      "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_unref(form).backupContact) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[226] || (_cache[226] = _createElementVNode("p", { class: "sc__field" }, " 법정 신고·제출 일정은 별도 법령과 기관의 의무를 따른다. 본 일정은 적법한 신고대리 권한을 부여하는 의미가 아니다. ", -1)),
                  _cache[227] || (_cache[227] = _createElementVNode("h3", null, "2. 갑이 제공하는 자료", -1)),
                  _createElementVNode("p", _hoisted_55, [
                    _cache[203] || (_cache[203] = _createTextVNode(" 임금관리 선택 시: ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).wageDocs.contract,
                      disabled: _unref(form).wageSelect !== 'selected',
                      "aria-label": "근로계약·임금조건",
                      onPick: _cache[64] || (_cache[64] = ($event: any) => (_unref(form).wageDocs.contract = !_unref(form).wageDocs.contract))
                    }, null, 8, ["on", "disabled"]),
                    _cache[204] || (_cache[204] = _createTextVNode(" 근로계약·임금조건 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).wageDocs.attendance,
                      disabled: _unref(form).wageSelect !== 'selected',
                      "aria-label": "근무표·근태",
                      onPick: _cache[65] || (_cache[65] = ($event: any) => (_unref(form).wageDocs.attendance = !_unref(form).wageDocs.attendance))
                    }, null, 8, ["on", "disabled"]),
                    _cache[205] || (_cache[205] = _createTextVNode(" 근무표·근태 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).wageDocs.hr,
                      disabled: _unref(form).wageSelect !== 'selected',
                      "aria-label": "입사·퇴사·휴직정보",
                      onPick: _cache[66] || (_cache[66] = ($event: any) => (_unref(form).wageDocs.hr = !_unref(form).wageDocs.hr))
                    }, null, 8, ["on", "disabled"]),
                    _cache[206] || (_cache[206] = _createTextVNode(" 입사·퇴사·휴직정보 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).wageDocs.allowance,
                      disabled: _unref(form).wageSelect !== 'selected',
                      "aria-label": "수당·공제항목",
                      onPick: _cache[67] || (_cache[67] = ($event: any) => (_unref(form).wageDocs.allowance = !_unref(form).wageDocs.allowance))
                    }, null, 8, ["on", "disabled"]),
                    _cache[207] || (_cache[207] = _createTextVNode(" 수당·공제항목 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).wageDocs.account,
                      disabled: _unref(form).wageSelect !== 'selected',
                      "aria-label": "지급·계좌변경",
                      onPick: _cache[68] || (_cache[68] = ($event: any) => (_unref(form).wageDocs.account = !_unref(form).wageDocs.account))
                    }, null, 8, ["on", "disabled"]),
                    _cache[208] || (_cache[208] = _createTextVNode(" 지급·계좌변경 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).wageDocs.other,
                      disabled: _unref(form).wageSelect !== 'selected',
                      "aria-label": "기타",
                      onPick: _cache[69] || (_cache[69] = ($event: any) => (_unref(form).wageDocs.other = !_unref(form).wageDocs.other))
                    }, null, 8, ["on", "disabled"]),
                    _cache[209] || (_cache[209] = _createTextVNode(" 기타 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).wageDocs.otherText,
                      "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_unref(form).wageDocs.otherText) = $event)),
                      width: 6,
                      disabled: _unref(form).wageSelect !== 'selected' || !_unref(form).wageDocs.other
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _createElementVNode("p", _hoisted_56, [
                    _cache[210] || (_cache[210] = _createTextVNode(" 재무회계 선택 시: ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).acctDocs.transactions,
                      disabled: _unref(form).acctSelect !== 'selected',
                      "aria-label": "거래내역",
                      onPick: _cache[71] || (_cache[71] = ($event: any) => (_unref(form).acctDocs.transactions = !_unref(form).acctDocs.transactions))
                    }, null, 8, ["on", "disabled"]),
                    _cache[211] || (_cache[211] = _createTextVNode(" 거래내역 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).acctDocs.evidence,
                      disabled: _unref(form).acctSelect !== 'selected',
                      "aria-label": "수입·지출 증빙",
                      onPick: _cache[72] || (_cache[72] = ($event: any) => (_unref(form).acctDocs.evidence = !_unref(form).acctDocs.evidence))
                    }, null, 8, ["on", "disabled"]),
                    _cache[212] || (_cache[212] = _createTextVNode(" 수입·지출 증빙 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).acctDocs.subsidy,
                      disabled: _unref(form).acctSelect !== 'selected',
                      "aria-label": "보조금·장기요양급여 관련 내역",
                      onPick: _cache[73] || (_cache[73] = ($event: any) => (_unref(form).acctDocs.subsidy = !_unref(form).acctDocs.subsidy))
                    }, null, 8, ["on", "disabled"]),
                    _cache[213] || (_cache[213] = _createTextVNode(" 보조금·장기요양급여 관련 내역 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).acctDocs.prevBooks,
                      disabled: _unref(form).acctSelect !== 'selected',
                      "aria-label": "전월 장부",
                      onPick: _cache[74] || (_cache[74] = ($event: any) => (_unref(form).acctDocs.prevBooks = !_unref(form).acctDocs.prevBooks))
                    }, null, 8, ["on", "disabled"]),
                    _cache[214] || (_cache[214] = _createTextVNode(" 전월 장부 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).acctDocs.other,
                      disabled: _unref(form).acctSelect !== 'selected',
                      "aria-label": "기타",
                      onPick: _cache[75] || (_cache[75] = ($event: any) => (_unref(form).acctDocs.other = !_unref(form).acctDocs.other))
                    }, null, 8, ["on", "disabled"]),
                    _cache[215] || (_cache[215] = _createTextVNode(" 기타 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).acctDocs.otherText,
                      "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_unref(form).acctDocs.otherText) = $event)),
                      width: 6,
                      disabled: _unref(form).acctSelect !== 'selected' || !_unref(form).acctDocs.other
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _cache[228] || (_cache[228] = _createElementVNode("p", { class: "sc__field" }, " 갑은 자료의 사실성·완전성 및 제공 권한을 확인한다. 고유식별정보 등은 허용된 안전한 수단과 필요한 최소 범위로만 제공한다. ", -1)),
                  _cache[229] || (_cache[229] = _createElementVNode("h3", null, "3. 오류·지연 대응", -1)),
                  _createElementVNode("p", _hoisted_57, [
                    _cache[216] || (_cache[216] = _createTextVNode(" 을의 처리오류 발견 시 갑 통지 경로 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).errorNotifyPath,
                      "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_unref(form).errorNotifyPath) = $event))
                    }, null, 8, ["modelValue"]),
                    _cache[217] || (_cache[217] = _createTextVNode(" / 을의 1차 회신 목표 [영업일 ", -1)),
                    _createVNode(ScEditText, {
                      modelValue: _unref(form).replyBusinessDays,
                      "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_unref(form).replyBusinessDays) = $event)),
                      width: 4,
                      numeric: ""
                    }, null, 8, ["modelValue"]),
                    _cache[218] || (_cache[218] = _createTextVNode("일 이내] ", -1))
                  ]),
                  _cache[230] || (_cache[230] = _createElementVNode("p", { class: "sc__field" }, " 갑의 자료누락·변경 확인 시 을은 보완사항을 통지하고, 보완 완료 후 재처리 일정과 추가비용 여부를 안내한다. ", -1)),
                  _cache[231] || (_cache[231] = _createElementVNode("p", { class: "sc__field" }, "대금·업무범위 변경은 별첨 1·2에 따른 합의 후 적용한다.", -1)),
                  _cache[232] || (_cache[232] = _createElementVNode("h3", null, "4. 확인", -1)),
                  _createElementVNode("p", _hoisted_58, [
                    _createElementVNode("span", null, [
                      _cache[219] || (_cache[219] = _createTextVNode(" 갑 담당자 ", -1)),
                      _createVNode(ScEditText, {
                        "model-value": _unref(form).annex3PartyA || _unref(form).contactName,
                        "onUpdate:modelValue": setAnnex3PartyA
                      }, null, 8, ["model-value"]),
                      _cache[220] || (_cache[220] = _createTextVNode(" / 을 담당자 ", -1)),
                      _createVNode(ScEditText, {
                        modelValue: _unref(form).annex3PartyB,
                        "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_unref(form).annex3PartyB) = $event))
                      }, null, 8, ["modelValue"]),
                      _cache[221] || (_cache[221] = _createTextVNode(" / 확인일 ", -1)),
                      _createVNode(ScEditDate, {
                        y: _unref(form).annex3ConfirmYear,
                        "onUpdate:y": _cache[80] || (_cache[80] = ($event: any) => ((_unref(form).annex3ConfirmYear) = $event)),
                        m: _unref(form).annex3ConfirmMonth,
                        "onUpdate:m": _cache[81] || (_cache[81] = ($event: any) => ((_unref(form).annex3ConfirmMonth) = $event)),
                        d: _unref(form).annex3ConfirmDay,
                        "onUpdate:d": _cache[82] || (_cache[82] = ($event: any) => ((_unref(form).annex3ConfirmDay) = $event))
                      }, null, 8, ["y", "m", "d"])
                    ]),
                    _createElementVNode("img", {
                      class: "sc__seal",
                      src: _unref(HAMWOORI_SEAL),
                      alt: "주식회사 함우리 직인",
                      width: "56",
                      height: "56"
                    }, null, 8, _hoisted_59)
                  ])
                ], 2), [
                  [_vShow, tab.value === 'annex3']
                ]),
                _withDirectives(_createElementVNode("section", {
                  ref_key: "panelAnnex4",
                  ref: panelAnnex4,
                  class: _normalizeClass(["sc__panel", { 'is-active': tab.value === 'annex4' }])
                }, [
                  _cache[250] || (_cache[250] = _createElementVNode("div", { class: "sc__topline" }, null, -1)),
                  _cache[251] || (_cache[251] = _createElementVNode("p", { class: "sc__doctype" }, "별첨 4", -1)),
                  _cache[252] || (_cache[252] = _createElementVNode("h2", null, "개인정보 처리위탁 부속합의서", -1)),
                  _createElementVNode("div", {
                    class: "sc__articles",
                    innerHTML: annex4Html
                  }),
                  _createElementVNode("p", _hoisted_60, [
                    _cache[233] || (_cache[233] = _createTextVNode(" 개인정보 재위탁 현황: ① 업체명 ", -1)),
                    _createVNode(ScEditText, {
                      "model-value": reconsignVal('reconsign1', 'vendor'),
                      width: 8,
                      disabled: _unref(form).reconsignNone,
                      "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => (_unref(form).reconsign1.vendor = $event))
                    }, null, 8, ["model-value", "disabled"]),
                    _cache[234] || (_cache[234] = _createTextVNode(" / 업무 ", -1)),
                    _createVNode(ScEditText, {
                      "model-value": reconsignVal('reconsign1', 'work'),
                      width: 8,
                      disabled: _unref(form).reconsignNone,
                      "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => (_unref(form).reconsign1.work = $event))
                    }, null, 8, ["model-value", "disabled"]),
                    _cache[235] || (_cache[235] = _createTextVNode(" / 처리항목 ", -1)),
                    _createVNode(ScEditText, {
                      "model-value": reconsignVal('reconsign1', 'items'),
                      width: 8,
                      disabled: _unref(form).reconsignNone,
                      "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => (_unref(form).reconsign1.items = $event))
                    }, null, 8, ["model-value", "disabled"]),
                    _cache[236] || (_cache[236] = _createTextVNode(" / 갑 동의일 ", -1)),
                    _createVNode(ScEditText, {
                      "model-value": reconsignVal('reconsign1', 'agreedDate'),
                      width: 8,
                      disabled: _unref(form).reconsignNone,
                      "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => (_unref(form).reconsign1.agreedDate = $event))
                    }, null, 8, ["model-value", "disabled"])
                  ]),
                  _createElementVNode("p", _hoisted_61, [
                    _cache[237] || (_cache[237] = _createTextVNode(" ② 업체명 ", -1)),
                    _createVNode(ScEditText, {
                      "model-value": reconsignVal('reconsign2', 'vendor'),
                      width: 8,
                      disabled: _unref(form).reconsignNone,
                      "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => (_unref(form).reconsign2.vendor = $event))
                    }, null, 8, ["model-value", "disabled"]),
                    _cache[238] || (_cache[238] = _createTextVNode(" / 업무 ", -1)),
                    _createVNode(ScEditText, {
                      "model-value": reconsignVal('reconsign2', 'work'),
                      width: 8,
                      disabled: _unref(form).reconsignNone,
                      "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => (_unref(form).reconsign2.work = $event))
                    }, null, 8, ["model-value", "disabled"]),
                    _cache[239] || (_cache[239] = _createTextVNode(" / 처리항목 ", -1)),
                    _createVNode(ScEditText, {
                      "model-value": reconsignVal('reconsign2', 'items'),
                      width: 8,
                      disabled: _unref(form).reconsignNone,
                      "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => (_unref(form).reconsign2.items = $event))
                    }, null, 8, ["model-value", "disabled"]),
                    _cache[240] || (_cache[240] = _createTextVNode(" / 갑 동의일 ", -1)),
                    _createVNode(ScEditText, {
                      "model-value": reconsignVal('reconsign2', 'agreedDate'),
                      width: 8,
                      disabled: _unref(form).reconsignNone,
                      "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => (_unref(form).reconsign2.agreedDate = $event))
                    }, null, 8, ["model-value", "disabled"])
                  ]),
                  _createElementVNode("p", _hoisted_62, [
                    _cache[241] || (_cache[241] = _createTextVNode(" 재위탁이 없는 경우 ", -1)),
                    _createVNode(ScMark, {
                      on: _unref(form).reconsignNone,
                      "aria-label": "재위탁 해당 없음",
                      onPick: _cache[91] || (_cache[91] = ($event: any) => (_unref(form).reconsignNone = !_unref(form).reconsignNone))
                    }, null, 8, ["on"]),
                    _cache[242] || (_cache[242] = _createTextVNode(" 해당 없음. 본 항목의 공란은 재위탁 동의로 간주되지 않는다. ", -1))
                  ]),
                  _cache[253] || (_cache[253] = _createElementVNode("h3", null, "확인 및 서명", -1)),
                  _createElementVNode("p", _hoisted_63, [
                    _createElementVNode("span", null, [
                      _cache[245] || (_cache[245] = _createTextVNode(" 갑 기관명 ", -1)),
                      _createVNode(ScEditText, {
                        modelValue: _unref(form).orgName,
                        "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((_unref(form).orgName) = $event))
                      }, null, 8, ["modelValue"]),
                      _cache[246] || (_cache[246] = _createTextVNode(" 대표자 ", -1)),
                      _createVNode(ScEditText, {
                        "model-value": _unref(form).partyASignName || _unref(form).representative,
                        width: 8,
                        "onUpdate:modelValue": setSignName
                      }, null, 8, ["model-value"]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "sc__sig-slot sc__sig-slot--btn",
                        "aria-label": "갑 서명 입력",
                        onClick: _cache[93] || (_cache[93] = ($event: any) => (openSheet('sign')))
                      }, [
                        _cache[243] || (_cache[243] = _createTextVNode("(서명)", -1)),
                        (_unref(form).partyASignImage)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "sc__sig-img",
                              src: _unref(form).partyASignImage,
                              alt: "갑 전자서명"
                            }, null, 8, _hoisted_64))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[247] || (_cache[247] = _createTextVNode(" 을 ", -1)),
                      _createElementVNode("span", _hoisted_65, _toDisplayString(_unref(form).partyBLegalName), 1),
                      _cache[248] || (_cache[248] = _createTextVNode(" 대표자 ", -1)),
                      _createElementVNode("span", _hoisted_66, _toDisplayString(_unref(form).partyBOwner), 1),
                      _createElementVNode("span", _hoisted_67, [
                        _cache[244] || (_cache[244] = _createTextVNode("(서명)", -1)),
                        _createElementVNode("img", {
                          class: "sc__seal",
                          src: _unref(HAMWOORI_SEAL),
                          alt: "주식회사 함우리 직인",
                          width: "56",
                          height: "56"
                        }, null, 8, _hoisted_68)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_69, [
                    _cache[249] || (_cache[249] = _createTextVNode(" 합의일 ", -1)),
                    _createVNode(ScEditDate, {
                      y: _unref(form).annex4AgreedYear,
                      "onUpdate:y": _cache[94] || (_cache[94] = ($event: any) => ((_unref(form).annex4AgreedYear) = $event)),
                      m: _unref(form).annex4AgreedMonth,
                      "onUpdate:m": _cache[95] || (_cache[95] = ($event: any) => ((_unref(form).annex4AgreedMonth) = $event)),
                      d: _unref(form).annex4AgreedDay,
                      "onUpdate:d": _cache[96] || (_cache[96] = ($event: any) => ((_unref(form).annex4AgreedDay) = $event))
                    }, null, 8, ["y", "m", "d"])
                  ])
                ], 2), [
                  [_vShow, tab.value === 'annex4']
                ]),
                _withDirectives(_createElementVNode("section", {
                  ref_key: "panelSummary",
                  ref: panelSummary,
                  class: _normalizeClass(["sc__panel", { 'is-active': tab.value === 'summary' }])
                }, [
                  _cache[267] || (_cache[267] = _createElementVNode("div", { class: "sc__topline" }, null, -1)),
                  _cache[268] || (_cache[268] = _createElementVNode("p", { class: "sc__doctype" }, "원장·센터장용 안내 · 1~2페이지 분량", -1)),
                  _cache[269] || (_cache[269] = _createElementVNode("h2", null, "원장·센터장용 계약 핵심 안내", -1)),
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _cache[257] || (_cache[257] = _createElementVNode("h3", null, "한눈에 보는 계약", -1)),
                      _createElementVNode("p", null, " 계약 당사자: 장기요양기관(갑) ↔ " + _toDisplayString(_unref(form).partyBLegalName || _unref(company).legalName) + "(을). 임금관리만, 재무회계만 또는 두 서비스를 모두 신청할 수 있습니다. ", 1),
                      _cache[258] || (_cache[258] = _createElementVNode("p", null, " 서비스 시작연월과 실제 이용요금은 본문이 아닌 별첨 1·2에서 선택한 서비스별로 확정합니다. 선택하지 않은 서비스는 업무 제공과 이용료 청구가 없습니다. ", -1)),
                      _createElementVNode("p", null, [
                        _cache[254] || (_cache[254] = _createTextVNode(" 현재 입력: 기관 ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_unref(form).orgName || '미입력'), 1),
                        _cache[255] || (_cache[255] = _createTextVNode(" · 임금관리 ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(selectLabel(_unref(form).wageSelect)), 1),
                        _cache[256] || (_cache[256] = _createTextVNode(" · 재무회계 ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(selectLabel(_unref(form).acctSelect)), 1)
                      ]),
                      _cache[259] || (_cache[259] = _createElementVNode("p", { class: "sc__disclaimer" }, " 신청 예시: ① 임금관리만 신청 → 임금업무만 진행 ② 재무회계만 신청 → 회계업무만 진행 ③ 모두 신청 → 두 업무 진행 ", -1)),
                      _cache[260] || (_cache[260] = _createElementVNode("p", null, " 계약기간은 최초로 시작되는 유료 서비스의 개시월부터 1년이며, 추가 서비스는 공통 종료일에 맞춰 운영합니다. ", -1))
                    ]),
                    _cache[266] || (_cache[266] = _createStaticVNode("<div class=\"sc__box\"><h3>무엇을 도와주나요?</h3><p> 임금관리(신청 시에만): 제공된 근무·근로조건 자료를 기준으로 급여 산출과 급여대장·명세서, 신고용 기초자료 등을 지원합니다. </p><p> 재무회계(신청 시에만): 제공된 거래·증빙을 기준으로 수입·지출 분류, 전표·장부 정리와 예산·결산의 기초자료 작성을 지원합니다. </p><p> 세무·노무 분야의 법적 대리나 전문자격이 필요한 업무는 별도 적격 전문가와 진행해야 하며, 이 계약만으로 포함되지 않습니다. </p></div><div class=\"sc__box\"><h3>기관이 꼭 해야 할 일</h3><p> 신청한 서비스에 필요한 근무표·입퇴사·수당 기준 또는 거래증빙만 정해진 날까지 제출합니다. 급여 지급과 예산·결산 승인, 법정 신고 등 해당 법적 의무는 기관에 있습니다. </p><p> 함우리가 제공한 산출물은 지급·제출 전에 확인하고 오류를 발견하면 즉시 알려주세요. </p></div><div class=\"sc__box\"><h3>비용·변경·해지</h3><p> 실제로 선택·개시한 서비스의 월 이용료만 청구합니다. 인원 초과분, 할인, 청구·납부일과 개시·종료월 정산방법은 별첨 2에 기재하며, 미선택 서비스 비용은 발생하지 않습니다. </p><p> 미선택 서비스를 추가하거나 기존 서비스를 변경할 때에는 별첨 1·2에 별도로 합의합니다. 한 서비스를 해지해도 다른 서비스는 계속 이용할 수 있고, 종료된 서비스의 비용은 종료일까지 정산합니다. </p></div><div class=\"sc__box\"><h3>개인정보 및 종료 후 자료</h3><p> 급여·인사정보는 계약된 업무 수행에만 사용하고, 외부 처리업체에 재위탁할 경우 필요한 사전 동의·고지 절차를 거칩니다. </p><p> 계약 종료 후에는 정해진 절차에 따라 데이터를 인계하고, 법령상 보존이 필요한 자료를 제외하고 반환·파기합니다. </p></div>", 4)),
                    _createElementVNode("div", _hoisted_72, [
                      _cache[265] || (_cache[265] = _createElementVNode("h3", null, "서명 전에 확인할 별첨", -1)),
                      _createElementVNode("p", null, [
                        _createVNode(ScMark, {
                          on: _unref(form).annexAgreed.a1,
                          "aria-label": "별첨 1 합의",
                          onPick: _cache[97] || (_cache[97] = ($event: any) => (_unref(form).annexAgreed.a1 = !_unref(form).annexAgreed.a1))
                        }, null, 8, ["on"]),
                        _cache[261] || (_cache[261] = _createTextVNode(" 별첨 1: 임금관리·재무회계 각각 선택/미선택 및 시작연월 ", -1))
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(ScMark, {
                          on: _unref(form).annexAgreed.a2,
                          "aria-label": "별첨 2 합의",
                          onPick: _cache[98] || (_cache[98] = ($event: any) => (_unref(form).annexAgreed.a2 = !_unref(form).annexAgreed.a2))
                        }, null, 8, ["on"]),
                        _cache[262] || (_cache[262] = _createTextVNode(" 별첨 2: 선택 서비스의 요금·할인·납부조건", -1))
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(ScMark, {
                          on: _unref(form).annexAgreed.a3,
                          "aria-label": "별첨 3 합의",
                          onPick: _cache[99] || (_cache[99] = ($event: any) => (_unref(form).annexAgreed.a3 = !_unref(form).annexAgreed.a3))
                        }, null, 8, ["on"]),
                        _cache[263] || (_cache[263] = _createTextVNode(" 별첨 3: 자료 제출·업무 일정", -1))
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(ScMark, {
                          on: _unref(form).annexAgreed.a4,
                          "aria-label": "별첨 4 합의",
                          onPick: _cache[100] || (_cache[100] = ($event: any) => (_unref(form).annexAgreed.a4 = !_unref(form).annexAgreed.a4))
                        }, null, 8, ["on"]),
                        _cache[264] || (_cache[264] = _createTextVNode(" 별첨 4: 개인정보 처리위탁 및 재위탁", -1))
                      ])
                    ])
                  ]),
                  _cache[270] || (_cache[270] = _createElementVNode("p", { class: "sc__disclaimer" }, " ※ 본 안내문은 이해를 돕기 위한 요약입니다. 구체적 권리·의무는 서명된 계약서 본문과 별첨을 기준으로 합니다. ", -1))
                ], 2), [
                  [_vShow, tab.value === 'summary']
                ])
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "sc__fab",
                onClick: _cache[101] || (_cache[101] = ($event: any) => (openSheet()))
              }, [
                _cache[271] || (_cache[271] = _createTextVNode(" 정보 입력 ", -1)),
                (_unref(filledCount))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(_unref(filledCount)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(ServiceContractFormSheet, {
                open: sheetOpen.value,
                form: _unref(form),
                "initial-section": sheetSection.value,
                onClose: _cache[102] || (_cache[102] = ($event: any) => (sheetOpen.value = false))
              }, null, 8, ["open", "form", "initial-section"]),
              (pdfPreviewOpen.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "sc-pdf",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-label": "계약서 PDF 미리보기",
                    onClick: _withModifiers(closePdfPreview, ["self"])
                  }, [
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("header", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _cache[272] || (_cache[272] = _createElementVNode("p", { class: "sc-pdf__eyebrow" }, "계약서 전체 · 본문 + 별첨 1~4", -1)),
                          _createElementVNode("h2", _hoisted_77, _toDisplayString(pdfFilename.value || '계약서 PDF'), 1)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "sc-pdf__close",
                          "aria-label": "미리보기 닫기",
                          onClick: closePdfPreview
                        }, [
                          _createVNode(AppIcon, {
                            icon: "mdi-close",
                            size: 22
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_78, [
                        (pdfBusy.value && !pdfPreviewUrl.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_79, "서버에서 PDF를 만드는 중입니다…"))
                          : (pdfError.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_80, _toDisplayString(pdfError.value), 1))
                            : (pdfPreviewUrl.value)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  ref_key: "pdfPagesRef",
                                  ref: pdfPagesRef,
                                  class: "sc-pdf__pages"
                                }, null, 512))
                              : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("footer", _hoisted_81, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "sc__btn sc__btn--ghost",
                          onClick: closePdfPreview
                        }, "닫기"),
                        _createElementVNode("div", _hoisted_82, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "sc__btn sc__btn--ghost",
                            disabled: !pdfPreviewUrl.value || pdfBusy.value,
                            onClick: onOpenPdfTab
                          }, " 새 탭 ", 8, _hoisted_83),
                          _createElementVNode("button", {
                            type: "button",
                            class: "sc__btn sc__btn--teal",
                            disabled: !pdfBlob.value || pdfBusy.value,
                            onClick: onDownloadPdf
                          }, " 다운로드 ", 8, _hoisted_84)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64)),
    _createVNode(ContractDeleteModal, {
      open: deleteOpen.value,
      "org-name": deleteTargetName.value,
      busy: deleteBusy.value,
      error: deleteError.value,
      onClose: closeDelete,
      onConfirm: onConfirmDelete
    }, null, 8, ["open", "org-name", "busy", "error"]),
    _createVNode(ContractPasswordModal, {
      open: staffGateOpen.value,
      reason: staffGateReason.value,
      busy: staffGateBusy.value,
      error: staffGateError.value,
      onClose: closeStaffGate,
      onConfirm: onStaffGateConfirm
    }, null, 8, ["open", "reason", "busy", "error"])
  ]))
}
}

})